//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Authentication } from 'Authentication/Authentication';
import CurrentUserInformation from 'Authentication/CurrentUserInformation';
import { getSessionId } from 'requests/sessionId';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

export class BaseClient {
  async transformOptions(options: RequestInit): Promise<RequestInit> {
    options.headers = new Headers({
      'Content-Type': 'application/json;',
      Accept: 'application/json',
      Authorization: `Bearer ${await Authentication.Instance.GetToken()}`,
      'sekoia.session_id': getSessionId(),
      'sekoia.correlation_id': uuidv4(),
      'sekoia.customer_id': CurrentUserInformation.Instance.getUserInformation().customerId,
    });

    return options;
  }

  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.REACT_APP_NLL_MEDICINE_TASKS_BASE_URL)
      throw new Error('REACT_APP_NLL_MEDICINE_TASKS_BASE_URL must be set in environment');

    return process.env.REACT_APP_NLL_MEDICINE_TASKS_BASE_URL;
  }
}

export class MartenConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    rebuildProjection(customerId: string, projectionName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{customerId}/projections/{projectionName}/rebuild";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (projectionName === undefined || projectionName === null)
            throw new globalThis.Error("The parameter 'projectionName' must be defined.");
        url_ = url_.replace("{projectionName}", encodeURIComponent("" + projectionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRebuildProjection(_response);
        });
    }

    protected processRebuildProjection(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ResidentNarcoticMedicationRecordsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getResidentNarcoticsRecord(residentId: string): Promise<ResidentNarcoticsRecordResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentNarcoticsRecord(_response);
        });
    }

    protected processGetResidentNarcoticsRecord(response: Response): Promise<ResidentNarcoticsRecordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentNarcoticsRecordResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentNarcoticsRecordResponse>(null as any);
    }

    getEntries(residentId: string, nplId: string, request: GetResidentNarcoticMedicationRecordEntriesRequest): Promise<ResidentNarcoticMedicationRecordEntriesResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord/{nplId}/history";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntries(_response);
        });
    }

    protected processGetEntries(response: Response): Promise<ResidentNarcoticMedicationRecordEntriesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentNarcoticMedicationRecordEntriesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentNarcoticMedicationRecordEntriesResponse>(null as any);
    }

    adjustQuantity(residentId: string, nplId: string, request: AdjustNarcoticMedicationQuantityRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord/{nplId}/adjustQuantity";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdjustQuantity(_response);
        });
    }

    protected processAdjustQuantity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    dispenseNarcoticMedication(residentId: string, nplId: string, request: DispenseNarcoticMedicationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord/{nplId}/dispenseMedication";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDispenseNarcoticMedication(_response);
        });
    }

    protected processDispenseNarcoticMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restockNarcoticMedication(residentId: string, nplId: string, request: RestockNarcoticMedicationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord/{nplId}/restockMedication";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestockNarcoticMedication(_response);
        });
    }

    protected processRestockNarcoticMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    controlCount(residentId: string, nplId: string, request: NarcoticControlCountRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord/{nplId}/controlCount";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processControlCount(_response);
        });
    }

    protected processControlCount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    disposeNarcoticMedication(residentId: string, nplId: string, request: DisposeNarcoticMedicationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/narcoticsRecord/{nplId}/dispose";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisposeNarcoticMedication(_response);
        });
    }

    protected processDisposeNarcoticMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RecurrencePatternTemplatesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getRecurrencePatternTemplatesForDosageInstructions(request: RecurrencePatternTemplatesForDosageInstructionsRequest): Promise<RecurrencePatternTemplateResponse[]> {
        let url_ = this.baseUrl + "/api/recurrencePatterns/templates/dosageInstructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecurrencePatternTemplatesForDosageInstructions(_response);
        });
    }

    protected processGetRecurrencePatternTemplatesForDosageInstructions(response: Response): Promise<RecurrencePatternTemplateResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecurrencePatternTemplateResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecurrencePatternTemplateResponse[]>(null as any);
    }
}

export class RecurrencePatternsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    addRecurrencePattern(residentId: string, prescriptionChainId: string, prescriptionId: string, request: AddRecurrencePatternRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/recurrencePatterns";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddRecurrencePattern(_response);
        });
    }

    protected processAddRecurrencePattern(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateRecurrencePattern(residentId: string, prescriptionChainId: string, prescriptionId: string, recurrencePatternId: string, request: UpdateRecurrencePatternRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/recurrencePatterns/{recurrencePatternId}";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (recurrencePatternId === undefined || recurrencePatternId === null)
            throw new globalThis.Error("The parameter 'recurrencePatternId' must be defined.");
        url_ = url_.replace("{recurrencePatternId}", encodeURIComponent("" + recurrencePatternId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRecurrencePattern(_response);
        });
    }

    protected processUpdateRecurrencePattern(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteRecurrencePattern(residentId: string, prescriptionChainId: string, prescriptionId: string, recurrencePatternId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/recurrencePatterns/{recurrencePatternId}";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (recurrencePatternId === undefined || recurrencePatternId === null)
            throw new globalThis.Error("The parameter 'recurrencePatternId' must be defined.");
        url_ = url_.replace("{recurrencePatternId}", encodeURIComponent("" + recurrencePatternId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRecurrencePattern(_response);
        });
    }

    protected processDeleteRecurrencePattern(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    isRecurrencePatternContentReadOnly(residentId: string, prescriptionChainId: string, prescriptionId: string, recurrencePatternId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/recurrencePatterns/{recurrencePatternId}/isContentReadonly";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (recurrencePatternId === undefined || recurrencePatternId === null)
            throw new globalThis.Error("The parameter 'recurrencePatternId' must be defined.");
        url_ = url_.replace("{recurrencePatternId}", encodeURIComponent("" + recurrencePatternId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsRecurrencePatternContentReadOnly(_response);
        });
    }

    protected processIsRecurrencePatternContentReadOnly(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PrescriptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    compareWithStoredPrescriptions(residentId: string, request: CompareWithStoredPrescriptionsRequest): Promise<{ [key: string]: DifferenceResponse[]; }> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptions/compare";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompareWithStoredPrescriptions(_response);
        });
    }

    protected processCompareWithStoredPrescriptions(response: Response): Promise<{ [key: string]: DifferenceResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? resultData200[key].map((i: any) => DifferenceResponse.fromJS(i)) : [];
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: DifferenceResponse[]; }>(null as any);
    }

    getPrescriptionTimeline(residentId: string, prescriptionChainId: string, prescriptionId: string): Promise<PrescriptionTimelineResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/timeline";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionTimeline(_response);
        });
    }

    protected processGetPrescriptionTimeline(response: Response): Promise<PrescriptionTimelineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionTimelineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionTimelineResponse>(null as any);
    }
}

export class PrescriptionChainTaskConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPrescriptionChainTaskConfig(residentId: string, prescriptionChainId: string): Promise<PrescriptionChainTaskConfigResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/taskConfig";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainTaskConfig(_response);
        });
    }

    protected processGetPrescriptionChainTaskConfig(response: Response): Promise<PrescriptionChainTaskConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionChainTaskConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainTaskConfigResponse>(null as any);
    }

    updateDelegationTags(residentId: string, prescriptionChainId: string, request: UpdateDelegationTagsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/taskConfig/delegationTags";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDelegationTags(_response);
        });
    }

    protected processUpdateDelegationTags(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PrescriptionChainClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    addPrescriptionChain(residentId: string, prescriptionChainId: string, addPrescriptionChainRequest: AddPrescriptionChainRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addPrescriptionChainRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPrescriptionChain(_response);
        });
    }

    protected processAddPrescriptionChain(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updatePrescriptionChain(residentId: string, prescriptionChainId: string, request: UpdatePrescriptionChainRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePrescriptionChain(_response);
        });
    }

    protected processUpdatePrescriptionChain(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPrescriptionChainSummaries(residentId: string): Promise<PrescriptionChainSummaryResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/summary";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainSummaries(_response);
        });
    }

    protected processGetPrescriptionChainSummaries(response: Response): Promise<PrescriptionChainSummaryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionChainSummaryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainSummaryResponse[]>(null as any);
    }
}

export class PrescriptionChainMetadataClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPrescriptionChainsMetadata(residentId: string): Promise<PrescriptionChainMetadataResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChainsMetadata";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainsMetadata(_response);
        });
    }

    protected processGetPrescriptionChainsMetadata(response: Response): Promise<PrescriptionChainMetadataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionChainMetadataResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainMetadataResponse[]>(null as any);
    }

    getPrescriptionChainMetadata(residentId: string, prescriptionChainId: string): Promise<PrescriptionChainMetadataResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChainsMetadata/{prescriptionChainId}";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainMetadata(_response);
        });
    }

    protected processGetPrescriptionChainMetadata(response: Response): Promise<PrescriptionChainMetadataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionChainMetadataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainMetadataResponse>(null as any);
    }
}

export class PrescriptionChainEffectRegistrationEvaluationTimeOptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getEffectRegistrationEvaluationTimeOptions(residentId: string, prescriptionChainId: string): Promise<PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/effectRegistrationEvaluationTimeOptions";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEffectRegistrationEvaluationTimeOptions(_response);
        });
    }

    protected processGetEffectRegistrationEvaluationTimeOptions(response: Response): Promise<PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse>(null as any);
    }

    updateEffectRegistrationEvaluationTimeOptions(residentId: string, prescriptionChainId: string, request: UpdateEffectRegistrationEvaluationTimeOptionsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/effectRegistrationEvaluationTimeOptions";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEffectRegistrationEvaluationTimeOptions(_response);
        });
    }

    protected processUpdateEffectRegistrationEvaluationTimeOptions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PnMedicineClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPnPrescriptions(residentId: string): Promise<PnPrescriptionResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pnPrescriptions";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnPrescriptions(_response);
        });
    }

    protected processGetPnPrescriptions(response: Response): Promise<PnPrescriptionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PnPrescriptionResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnPrescriptionResponse[]>(null as any);
    }

    givePnMedicine(residentId: string, prescriptionId: string, nplId: string, request: GivePnMedicineRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pnPrescriptions/{prescriptionId}/availableMedication/{nplId}/give";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (nplId === undefined || nplId === null)
            throw new globalThis.Error("The parameter 'nplId' must be defined.");
        url_ = url_.replace("{nplId}", encodeURIComponent("" + nplId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGivePnMedicine(_response);
        });
    }

    protected processGivePnMedicine(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPnTasks(request: GetPnTasksRequest): Promise<PnTaskResponse[]> {
        let url_ = this.baseUrl + "/api/pnTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnTasks(_response);
        });
    }

    protected processGetPnTasks(response: Response): Promise<PnTaskResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PnTaskResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnTaskResponse[]>(null as any);
    }

    getPnMedicineTaskDetail(residentId: string, prescriptionId: string, pnMedicineTaskId: string): Promise<PnMedicineTaskDetailResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pnPrescriptions/{prescriptionId}/pnMedicineTasks/{pnMedicineTaskId}";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (pnMedicineTaskId === undefined || pnMedicineTaskId === null)
            throw new globalThis.Error("The parameter 'pnMedicineTaskId' must be defined.");
        url_ = url_.replace("{pnMedicineTaskId}", encodeURIComponent("" + pnMedicineTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnMedicineTaskDetail(_response);
        });
    }

    protected processGetPnMedicineTaskDetail(response: Response): Promise<PnMedicineTaskDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PnMedicineTaskDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnMedicineTaskDetailResponse>(null as any);
    }

    getPnMedicineEffectTaskDetail(residentId: string, prescriptionId: string, pnMedicineTaskId: string): Promise<PnMedicineEffectTaskDetailResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pnPrescriptions/{prescriptionId}/pnMedicineTasks/{pnMedicineTaskId}/effect";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (pnMedicineTaskId === undefined || pnMedicineTaskId === null)
            throw new globalThis.Error("The parameter 'pnMedicineTaskId' must be defined.");
        url_ = url_.replace("{pnMedicineTaskId}", encodeURIComponent("" + pnMedicineTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnMedicineEffectTaskDetail(_response);
        });
    }

    protected processGetPnMedicineEffectTaskDetail(response: Response): Promise<PnMedicineEffectTaskDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PnMedicineEffectTaskDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnMedicineEffectTaskDetailResponse>(null as any);
    }

    cancelPnMedicineTask(residentId: string, prescriptionId: string, pnMedicineTaskId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pnPrescriptions/{prescriptionId}/pnMedicineTasks/{pnMedicineTaskId}/cancel";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (pnMedicineTaskId === undefined || pnMedicineTaskId === null)
            throw new globalThis.Error("The parameter 'pnMedicineTaskId' must be defined.");
        url_ = url_.replace("{pnMedicineTaskId}", encodeURIComponent("" + pnMedicineTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelPnMedicineTask(_response);
        });
    }

    protected processCancelPnMedicineTask(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    registerEffect(residentId: string, prescriptionId: string, pnMedicineTaskId: string, request: RegisterEffectRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pnPrescriptions/{prescriptionId}/pnMedicineTasks/{pnMedicineTaskId}/registerEffect";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (pnMedicineTaskId === undefined || pnMedicineTaskId === null)
            throw new globalThis.Error("The parameter 'pnMedicineTaskId' must be defined.");
        url_ = url_.replace("{pnMedicineTaskId}", encodeURIComponent("" + pnMedicineTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterEffect(_response);
        });
    }

    protected processRegisterEffect(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PlanningClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPrescriptionChainPlanning(residentId: string, prescriptionChainId: string): Promise<PrescriptionChainPlanningResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/planning";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainPlanning(_response);
        });
    }

    protected processGetPrescriptionChainPlanning(response: Response): Promise<PrescriptionChainPlanningResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionChainPlanningResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainPlanningResponse>(null as any);
    }

    activatePrescriptionChainPlanning(residentId: string, prescriptionChainId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/planning/activate";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivatePrescriptionChainPlanning(_response);
        });
    }

    protected processActivatePrescriptionChainPlanning(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deactivatePrescriptionChainPlanning(residentId: string, prescriptionChainId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/planning/deactivate";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivatePrescriptionChainPlanning(_response);
        });
    }

    protected processDeactivatePrescriptionChainPlanning(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DispensedPackagingTaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getDispensedPackagingTaskDetail(residentId: string, dispensedPackagingTaskId: string): Promise<DispensedPackagingTaskDetailResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dispensedPackagingTasks/{dispensedPackagingTaskId}/details";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dispensedPackagingTaskId === undefined || dispensedPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dispensedPackagingTaskId' must be defined.");
        url_ = url_.replace("{dispensedPackagingTaskId}", encodeURIComponent("" + dispensedPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDispensedPackagingTaskDetail(_response);
        });
    }

    protected processGetDispensedPackagingTaskDetail(response: Response): Promise<DispensedPackagingTaskDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DispensedPackagingTaskDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DispensedPackagingTaskDetailResponse>(null as any);
    }

    giveMedication(residentId: string, dispensedPackagingTaskId: string, request: GiveMedicationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dispensedPackagingTasks/{dispensedPackagingTaskId}/actions/giveMedication";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dispensedPackagingTaskId === undefined || dispensedPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dispensedPackagingTaskId' must be defined.");
        url_ = url_.replace("{dispensedPackagingTaskId}", encodeURIComponent("" + dispensedPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiveMedication(_response);
        });
    }

    protected processGiveMedication(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    undoAction(residentId: string, dispensedPackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dispensedPackagingTasks/{dispensedPackagingTaskId}/actions/undo";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dispensedPackagingTaskId === undefined || dispensedPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dispensedPackagingTaskId' must be defined.");
        url_ = url_.replace("{dispensedPackagingTaskId}", encodeURIComponent("" + dispensedPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndoAction(_response);
        });
    }

    protected processUndoAction(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationNotGiven(residentId: string, dispensedPackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dispensedPackagingTasks/{dispensedPackagingTaskId}/actions/medicationNotGiven";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dispensedPackagingTaskId === undefined || dispensedPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dispensedPackagingTaskId' must be defined.");
        url_ = url_.replace("{dispensedPackagingTaskId}", encodeURIComponent("" + dispensedPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationNotGiven(_response);
        });
    }

    protected processMedicationNotGiven(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationNotIngested(residentId: string, dispensedPackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dispensedPackagingTasks/{dispensedPackagingTaskId}/actions/medicationNotIngested";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dispensedPackagingTaskId === undefined || dispensedPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dispensedPackagingTaskId' must be defined.");
        url_ = url_.replace("{dispensedPackagingTaskId}", encodeURIComponent("" + dispensedPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationNotIngested(_response);
        });
    }

    protected processMedicationNotIngested(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationPartiallyGiven(residentId: string, dispensedPackagingTaskId: string, request: MedicationPartiallyGivenRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dispensedPackagingTasks/{dispensedPackagingTaskId}/actions/medicationPartiallyGiven";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dispensedPackagingTaskId === undefined || dispensedPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dispensedPackagingTaskId' must be defined.");
        url_ = url_.replace("{dispensedPackagingTaskId}", encodeURIComponent("" + dispensedPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationPartiallyGiven(_response);
        });
    }

    protected processMedicationPartiallyGiven(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DosePackagingTaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getDosePackagingTaskDetail(residentId: string, dosePackagingTaskId: string): Promise<DosePackagingTaskDetailResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dosePackagingTasks/{dosePackagingTaskId}/details";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dosePackagingTaskId === undefined || dosePackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dosePackagingTaskId' must be defined.");
        url_ = url_.replace("{dosePackagingTaskId}", encodeURIComponent("" + dosePackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDosePackagingTaskDetail(_response);
        });
    }

    protected processGetDosePackagingTaskDetail(response: Response): Promise<DosePackagingTaskDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DosePackagingTaskDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DosePackagingTaskDetailResponse>(null as any);
    }

    giveMedication(residentId: string, dosePackagingTaskId: string, request: GiveMedicationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dosePackagingTasks/{dosePackagingTaskId}/actions/giveMedication";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dosePackagingTaskId === undefined || dosePackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dosePackagingTaskId' must be defined.");
        url_ = url_.replace("{dosePackagingTaskId}", encodeURIComponent("" + dosePackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiveMedication(_response);
        });
    }

    protected processGiveMedication(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    undoAction(residentId: string, dosePackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dosePackagingTasks/{dosePackagingTaskId}/actions/undo";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dosePackagingTaskId === undefined || dosePackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dosePackagingTaskId' must be defined.");
        url_ = url_.replace("{dosePackagingTaskId}", encodeURIComponent("" + dosePackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndoAction(_response);
        });
    }

    protected processUndoAction(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationNotGiven(residentId: string, dosePackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dosePackagingTasks/{dosePackagingTaskId}/actions/medicationNotGiven";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dosePackagingTaskId === undefined || dosePackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dosePackagingTaskId' must be defined.");
        url_ = url_.replace("{dosePackagingTaskId}", encodeURIComponent("" + dosePackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationNotGiven(_response);
        });
    }

    protected processMedicationNotGiven(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationNotIngested(residentId: string, dosePackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dosePackagingTasks/{dosePackagingTaskId}/actions/medicationNotIngested";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dosePackagingTaskId === undefined || dosePackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dosePackagingTaskId' must be defined.");
        url_ = url_.replace("{dosePackagingTaskId}", encodeURIComponent("" + dosePackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationNotIngested(_response);
        });
    }

    protected processMedicationNotIngested(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationPartiallyGiven(residentId: string, dosePackagingTaskId: string, request: MedicationPartiallyGivenRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/dosePackagingTasks/{dosePackagingTaskId}/actions/medicationPartiallyGiven";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dosePackagingTaskId === undefined || dosePackagingTaskId === null)
            throw new globalThis.Error("The parameter 'dosePackagingTaskId' must be defined.");
        url_ = url_.replace("{dosePackagingTaskId}", encodeURIComponent("" + dosePackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationPartiallyGiven(_response);
        });
    }

    protected processMedicationPartiallyGiven(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class OriginalPackagingTaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getOriginalPackagingTaskDetail(residentId: string, originalPackagingTaskId: string): Promise<OriginalPackagingTaskDetailResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/originalPackagingTasks/{originalPackagingTaskId}/details";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (originalPackagingTaskId === undefined || originalPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'originalPackagingTaskId' must be defined.");
        url_ = url_.replace("{originalPackagingTaskId}", encodeURIComponent("" + originalPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOriginalPackagingTaskDetail(_response);
        });
    }

    protected processGetOriginalPackagingTaskDetail(response: Response): Promise<OriginalPackagingTaskDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OriginalPackagingTaskDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OriginalPackagingTaskDetailResponse>(null as any);
    }

    giveMedication(residentId: string, originalPackagingTaskId: string, request: GiveMedicationWithAmountRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/originalPackagingTasks/{originalPackagingTaskId}/actions/giveMedication";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (originalPackagingTaskId === undefined || originalPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'originalPackagingTaskId' must be defined.");
        url_ = url_.replace("{originalPackagingTaskId}", encodeURIComponent("" + originalPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiveMedication(_response);
        });
    }

    protected processGiveMedication(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    undoAction(residentId: string, originalPackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/originalPackagingTasks/{originalPackagingTaskId}/actions/undo";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (originalPackagingTaskId === undefined || originalPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'originalPackagingTaskId' must be defined.");
        url_ = url_.replace("{originalPackagingTaskId}", encodeURIComponent("" + originalPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndoAction(_response);
        });
    }

    protected processUndoAction(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationNotIngested(residentId: string, originalPackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/originalPackagingTasks/{originalPackagingTaskId}/actions/medicationNotIngested";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (originalPackagingTaskId === undefined || originalPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'originalPackagingTaskId' must be defined.");
        url_ = url_.replace("{originalPackagingTaskId}", encodeURIComponent("" + originalPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationNotIngested(_response);
        });
    }

    protected processMedicationNotIngested(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    medicationNotGiven(residentId: string, originalPackagingTaskId: string, request: ActionWithReasonRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/originalPackagingTasks/{originalPackagingTaskId}/actions/medicationNotGiven";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (originalPackagingTaskId === undefined || originalPackagingTaskId === null)
            throw new globalThis.Error("The parameter 'originalPackagingTaskId' must be defined.");
        url_ = url_.replace("{originalPackagingTaskId}", encodeURIComponent("" + originalPackagingTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedicationNotGiven(_response);
        });
    }

    protected processMedicationNotGiven(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PlannedMedicineTaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPlannedMedicineTasksForResidents(request: PlannedMedicineTasksForResidentsRequest): Promise<PlannedMedicineTaskResponse[]> {
        let url_ = this.baseUrl + "/api/plannedMedicineTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlannedMedicineTasksForResidents(_response);
        });
    }

    protected processGetPlannedMedicineTasksForResidents(response: Response): Promise<PlannedMedicineTaskResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedMedicineTaskResponse[]>(null as any);
    }

    previewRecurrencePatternChanges(recurrencePatternId: string, request: PreviewChangesRequest): Promise<PreviewChangesResponse> {
        let url_ = this.baseUrl + "/api/plannedMedicineTasks/recurrencePatterns/{recurrencePatternId}/previewChanges";
        if (recurrencePatternId === undefined || recurrencePatternId === null)
            throw new globalThis.Error("The parameter 'recurrencePatternId' must be defined.");
        url_ = url_.replace("{recurrencePatternId}", encodeURIComponent("" + recurrencePatternId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviewRecurrencePatternChanges(_response);
        });
    }

    protected processPreviewRecurrencePatternChanges(response: Response): Promise<PreviewChangesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviewChangesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreviewChangesResponse>(null as any);
    }
}

export class MedicineTaskOrganisationConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getMedicineTaskOrganisationConfiguration(organisationId: string): Promise<MedicineTaskOrganisationConfigurationResponse> {
        let url_ = this.baseUrl + "/api/medicineTaskOrganisationConfiguration/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMedicineTaskOrganisationConfiguration(_response);
        });
    }

    protected processGetMedicineTaskOrganisationConfiguration(response: Response): Promise<MedicineTaskOrganisationConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicineTaskOrganisationConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicineTaskOrganisationConfigurationResponse>(null as any);
    }

    upsertOriginalPackagingTaskConfiguration(organisationId: string, request: UpsertDelegationTagConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/medicineTaskOrganisationConfiguration/{organisationId}/originalPackaging";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertOriginalPackagingTaskConfiguration(_response);
        });
    }

    protected processUpsertOriginalPackagingTaskConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upsertDosePackagingTaskConfiguration(organisationId: string, request: UpsertDelegationTagConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/medicineTaskOrganisationConfiguration/{organisationId}/dosePackaging";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertDosePackagingTaskConfiguration(_response);
        });
    }

    protected processUpsertDosePackagingTaskConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upsertDispensedPackagingTaskConfiguration(organisationId: string, request: UpsertDelegationTagConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/medicineTaskOrganisationConfiguration/{organisationId}/dispensedPackaging";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertDispensedPackagingTaskConfiguration(_response);
        });
    }

    protected processUpsertDispensedPackagingTaskConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upsertPnTaskConfiguration(organisationId: string, request: UpsertDelegationTagConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/medicineTaskOrganisationConfiguration/{organisationId}/pn";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertPnTaskConfiguration(_response);
        });
    }

    protected processUpsertPnTaskConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upsertDosageRouteDelegationTagConfiguration(organisationId: string, code: string, request: UpsertDosageRouteDelegationTagConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/medicineTaskOrganisationConfiguration/{organisationId}/dosageRoute/{code}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertDosageRouteDelegationTagConfiguration(_response);
        });
    }

    protected processUpsertDosageRouteDelegationTagConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MedicationConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getMedicationConfiguration(residentId: string, prescriptionChainId: string, prescriptionId: string): Promise<MedicationConfigurationResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/medicationConfiguration";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMedicationConfiguration(_response);
        });
    }

    protected processGetMedicationConfiguration(response: Response): Promise<MedicationConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationConfigurationResponse>(null as any);
    }

    updateMedicationConfiguration(residentId: string, prescriptionChainId: string, prescriptionId: string, request: UpdateMedicationConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/medicationConfiguration";
        if (residentId === undefined || residentId === null)
            throw new globalThis.Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new globalThis.Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new globalThis.Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMedicationConfiguration(_response);
        });
    }

    protected processUpdateMedicationConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EffectRegistrationEvaluationTimeOptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getEvaluationTimeOffsets(customerId: string): Promise<number[]> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/effectRegistrationEvaluationTimeOptions";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEvaluationTimeOffsets(_response);
        });
    }

    protected processGetEvaluationTimeOffsets(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    addEvaluationTimeOption(customerId: string, request: AddEffectRegistrationEvaluationTimeOptionRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/effectRegistrationEvaluationTimeOptions";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEvaluationTimeOption(_response);
        });
    }

    protected processAddEvaluationTimeOption(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEvaluationTimeOption(minutes: number, alsoRemoveIfCreatedOnChainConfig: boolean | undefined, customerId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/effectRegistrationEvaluationTimeOptions/{minutes}?";
        if (minutes === undefined || minutes === null)
            throw new globalThis.Error("The parameter 'minutes' must be defined.");
        url_ = url_.replace("{minutes}", encodeURIComponent("" + minutes));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (alsoRemoveIfCreatedOnChainConfig === null)
            throw new globalThis.Error("The parameter 'alsoRemoveIfCreatedOnChainConfig' cannot be null.");
        else if (alsoRemoveIfCreatedOnChainConfig !== undefined)
            url_ += "alsoRemoveIfCreatedOnChainConfig=" + encodeURIComponent("" + alsoRemoveIfCreatedOnChainConfig) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEvaluationTimeOption(_response);
        });
    }

    protected processDeleteEvaluationTimeOption(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ResidentNarcoticsRecordResponse implements IResidentNarcoticsRecordResponse {
    records!: ResidentNarcoticMedicationRecordResponse[];

    constructor(data?: IResidentNarcoticsRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.records = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(ResidentNarcoticMedicationRecordResponse.fromJS(item));
            }
            else {
                this.records = null as any;
            }
        }
    }

    static fromJS(data: any): ResidentNarcoticsRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentNarcoticsRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IResidentNarcoticsRecordResponse {
    records: ResidentNarcoticMedicationRecordResponse[];
}

export class ResidentNarcoticMedicationRecordResponse implements IResidentNarcoticMedicationRecordResponse {
    medication!: NarcoticMedicationResponse;
    doseUnit?: string | null;
    availableQuantity!: number;
    version!: number;

    constructor(data?: IResidentNarcoticMedicationRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new NarcoticMedicationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medication = _data["medication"] ? NarcoticMedicationResponse.fromJS(_data["medication"]) : new NarcoticMedicationResponse();
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
            this.availableQuantity = _data["availableQuantity"] !== undefined ? _data["availableQuantity"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): ResidentNarcoticMedicationRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentNarcoticMedicationRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        data["availableQuantity"] = this.availableQuantity !== undefined ? this.availableQuantity : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export interface IResidentNarcoticMedicationRecordResponse {
    medication: NarcoticMedicationResponse;
    doseUnit?: string | null;
    availableQuantity: number;
    version: number;
}

export class NarcoticMedicationResponse implements INarcoticMedicationResponse {
    nplId!: string;
    form?: string | null;
    strength?: string | null;
    interchangeSubstanceGroup?: string | null;
    productName?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    manufacturerName?: string | null;
    narcoticClassification!: NarcoticClassificationDto;

    constructor(data?: INarcoticMedicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.narcoticClassification = new NarcoticClassificationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.form = _data["form"] !== undefined ? _data["form"] : null as any;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : null as any;
            this.interchangeSubstanceGroup = _data["interchangeSubstanceGroup"] !== undefined ? _data["interchangeSubstanceGroup"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.atcClearText = _data["atcClearText"] !== undefined ? _data["atcClearText"] : null as any;
            this.atcCode = _data["atcCode"] !== undefined ? _data["atcCode"] : null as any;
            this.articleSummaryHtml = _data["articleSummaryHtml"] !== undefined ? _data["articleSummaryHtml"] : null as any;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null as any;
            this.narcoticClassification = _data["narcoticClassification"] ? NarcoticClassificationDto.fromJS(_data["narcoticClassification"]) : new NarcoticClassificationDto();
        }
    }

    static fromJS(data: any): NarcoticMedicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["form"] = this.form !== undefined ? this.form : null as any;
        data["strength"] = this.strength !== undefined ? this.strength : null as any;
        data["interchangeSubstanceGroup"] = this.interchangeSubstanceGroup !== undefined ? this.interchangeSubstanceGroup : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["atcClearText"] = this.atcClearText !== undefined ? this.atcClearText : null as any;
        data["atcCode"] = this.atcCode !== undefined ? this.atcCode : null as any;
        data["articleSummaryHtml"] = this.articleSummaryHtml !== undefined ? this.articleSummaryHtml : null as any;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null as any;
        data["narcoticClassification"] = this.narcoticClassification ? this.narcoticClassification.toJSON() : null as any;
        return data;
    }
}

export interface INarcoticMedicationResponse {
    nplId: string;
    form?: string | null;
    strength?: string | null;
    interchangeSubstanceGroup?: string | null;
    productName?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    manufacturerName?: string | null;
    narcoticClassification: NarcoticClassificationDto;
}

export class NarcoticClassificationDto implements INarcoticClassificationDto {
    code!: NarcoticClassificationCode;
    text!: string;

    constructor(data?: INarcoticClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): NarcoticClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface INarcoticClassificationDto {
    code: NarcoticClassificationCode;
    text: string;
}

export enum NarcoticClassificationCode {
    NotNarcotics = "NotNarcotics",
    NotApplicable = "NotApplicable",
    Classification1 = "Classification1",
    Classification2 = "Classification2",
    Classification3 = "Classification3",
    Classification4 = "Classification4",
    Classification5 = "Classification5",
}

export class ResidentNarcoticMedicationRecordEntriesResponse implements IResidentNarcoticMedicationRecordEntriesResponse {
    entries!: ResidentNarcoticMedicationRecordActionResponse[];
    nextEntryVersion?: number | null;

    constructor(data?: IResidentNarcoticMedicationRecordEntriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.entries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ResidentNarcoticMedicationRecordActionResponse.fromJS(item));
            }
            else {
                this.entries = null as any;
            }
            this.nextEntryVersion = _data["nextEntryVersion"] !== undefined ? _data["nextEntryVersion"] : null as any;
        }
    }

    static fromJS(data: any): ResidentNarcoticMedicationRecordEntriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentNarcoticMedicationRecordEntriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : null as any);
        }
        data["nextEntryVersion"] = this.nextEntryVersion !== undefined ? this.nextEntryVersion : null as any;
        return data;
    }
}

export interface IResidentNarcoticMedicationRecordEntriesResponse {
    entries: ResidentNarcoticMedicationRecordActionResponse[];
    nextEntryVersion?: number | null;
}

export class ResidentNarcoticMedicationRecordActionResponse implements IResidentNarcoticMedicationRecordActionResponse {
    version!: number;
    timestamp!: moment.Moment;
    residentId!: string;
    nplId!: string;
    performedBy!: string;
    resultingAvailableQuantity!: number;

    protected _discriminator: string;

    constructor(data?: IResidentNarcoticMedicationRecordActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ResidentNarcoticMedicationRecordActionResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : null as any;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.performedBy = _data["performedBy"] !== undefined ? _data["performedBy"] : null as any;
            this.resultingAvailableQuantity = _data["resultingAvailableQuantity"] !== undefined ? _data["resultingAvailableQuantity"] : null as any;
        }
    }

    static fromJS(data: any): ResidentNarcoticMedicationRecordActionResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "NarcoticMedicationQuantityAdjustedResponse") {
            let result = new NarcoticMedicationQuantityAdjustedResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NarcoticMedicationAdministeredResponse") {
            let result = new NarcoticMedicationAdministeredResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NarcoticMedicationDispensedResponse") {
            let result = new NarcoticMedicationDispensedResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NarcoticMedicationDisposedResponse") {
            let result = new NarcoticMedicationDisposedResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NarcoticControlCountResponse") {
            let result = new NarcoticControlCountResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NarcoticMedicationRestockedResponse") {
            let result = new NarcoticMedicationRestockedResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NarcoticMedicationUnadministeredResponse") {
            let result = new NarcoticMedicationUnadministeredResponse();
            result.init(data);
            return result;
        }
        let result = new ResidentNarcoticMedicationRecordActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["performedBy"] = this.performedBy !== undefined ? this.performedBy : null as any;
        data["resultingAvailableQuantity"] = this.resultingAvailableQuantity !== undefined ? this.resultingAvailableQuantity : null as any;
        return data;
    }
}

export interface IResidentNarcoticMedicationRecordActionResponse {
    version: number;
    timestamp: moment.Moment;
    residentId: string;
    nplId: string;
    performedBy: string;
    resultingAvailableQuantity: number;
}

export class NarcoticMedicationQuantityAdjustedResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticMedicationQuantityAdjustedResponse {
    comment!: string;

    constructor(data?: INarcoticMedicationQuantityAdjustedResponse) {
        super(data);
        this._discriminator = "NarcoticMedicationQuantityAdjustedResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticMedicationQuantityAdjustedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationQuantityAdjustedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticMedicationQuantityAdjustedResponse extends IResidentNarcoticMedicationRecordActionResponse {
    comment: string;
}

export class NarcoticMedicationAdministeredResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticMedicationAdministeredResponse {
    amount!: number;
    narcoticTaskType!: NarcoticTaskType;

    constructor(data?: INarcoticMedicationAdministeredResponse) {
        super(data);
        this._discriminator = "NarcoticMedicationAdministeredResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.narcoticTaskType = _data["narcoticTaskType"] !== undefined ? _data["narcoticTaskType"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticMedicationAdministeredResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationAdministeredResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["narcoticTaskType"] = this.narcoticTaskType !== undefined ? this.narcoticTaskType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticMedicationAdministeredResponse extends IResidentNarcoticMedicationRecordActionResponse {
    amount: number;
    narcoticTaskType: NarcoticTaskType;
}

export enum NarcoticTaskType {
    PnMedicine = "PnMedicine",
    OriginalPackaging = "OriginalPackaging",
}

export class NarcoticMedicationDispensedResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticMedicationDispensedResponse {
    amount!: number;
    comment?: string | null;

    constructor(data?: INarcoticMedicationDispensedResponse) {
        super(data);
        this._discriminator = "NarcoticMedicationDispensedResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticMedicationDispensedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationDispensedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticMedicationDispensedResponse extends IResidentNarcoticMedicationRecordActionResponse {
    amount: number;
    comment?: string | null;
}

export class NarcoticMedicationDisposedResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticMedicationDisposedResponse {
    amount!: number;
    reason!: string;

    constructor(data?: INarcoticMedicationDisposedResponse) {
        super(data);
        this._discriminator = "NarcoticMedicationDisposedResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticMedicationDisposedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationDisposedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticMedicationDisposedResponse extends IResidentNarcoticMedicationRecordActionResponse {
    amount: number;
    reason: string;
}

export class NarcoticControlCountResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticControlCountResponse {
    comment!: string;

    constructor(data?: INarcoticControlCountResponse) {
        super(data);
        this._discriminator = "NarcoticControlCountResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticControlCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticControlCountResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticControlCountResponse extends IResidentNarcoticMedicationRecordActionResponse {
    comment: string;
}

export class NarcoticMedicationRestockedResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticMedicationRestockedResponse {
    amount!: number;
    comment?: string | null;

    constructor(data?: INarcoticMedicationRestockedResponse) {
        super(data);
        this._discriminator = "NarcoticMedicationRestockedResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticMedicationRestockedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationRestockedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticMedicationRestockedResponse extends IResidentNarcoticMedicationRecordActionResponse {
    amount: number;
    comment?: string | null;
}

export class NarcoticMedicationUnadministeredResponse extends ResidentNarcoticMedicationRecordActionResponse implements INarcoticMedicationUnadministeredResponse {
    amount!: number;
    narcoticTaskType!: NarcoticTaskType;

    constructor(data?: INarcoticMedicationUnadministeredResponse) {
        super(data);
        this._discriminator = "NarcoticMedicationUnadministeredResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.narcoticTaskType = _data["narcoticTaskType"] !== undefined ? _data["narcoticTaskType"] : null as any;
        }
    }

    static override fromJS(data: any): NarcoticMedicationUnadministeredResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticMedicationUnadministeredResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["narcoticTaskType"] = this.narcoticTaskType !== undefined ? this.narcoticTaskType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INarcoticMedicationUnadministeredResponse extends IResidentNarcoticMedicationRecordActionResponse {
    amount: number;
    narcoticTaskType: NarcoticTaskType;
}

export class GetResidentNarcoticMedicationRecordEntriesRequest implements IGetResidentNarcoticMedicationRecordEntriesRequest {
    nextEntryVersion?: number | null;
    pageSize?: number | null;
    from?: moment.Moment | null;
    to?: moment.Moment | null;

    constructor(data?: IGetResidentNarcoticMedicationRecordEntriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextEntryVersion = _data["nextEntryVersion"] !== undefined ? _data["nextEntryVersion"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.from = _data["from"] ? moment(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? moment(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GetResidentNarcoticMedicationRecordEntriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResidentNarcoticMedicationRecordEntriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextEntryVersion"] = this.nextEntryVersion !== undefined ? this.nextEntryVersion : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IGetResidentNarcoticMedicationRecordEntriesRequest {
    nextEntryVersion?: number | null;
    pageSize?: number | null;
    from?: moment.Moment | null;
    to?: moment.Moment | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class AdjustNarcoticMedicationQuantityRequest implements IAdjustNarcoticMedicationQuantityRequest {
    quantity!: number;
    comment!: string;
    expectedCurrentVersion!: number;

    constructor(data?: IAdjustNarcoticMedicationQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
        }
    }

    static fromJS(data: any): AdjustNarcoticMedicationQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustNarcoticMedicationQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        return data;
    }
}

export interface IAdjustNarcoticMedicationQuantityRequest {
    quantity: number;
    comment: string;
    expectedCurrentVersion: number;
}

export class DispenseNarcoticMedicationRequest implements IDispenseNarcoticMedicationRequest {
    amount!: number;
    comment?: string | null;
    expectedCurrentVersion!: number;

    constructor(data?: IDispenseNarcoticMedicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
        }
    }

    static fromJS(data: any): DispenseNarcoticMedicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseNarcoticMedicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        return data;
    }
}

export interface IDispenseNarcoticMedicationRequest {
    amount: number;
    comment?: string | null;
    expectedCurrentVersion: number;
}

export class RestockNarcoticMedicationRequest implements IRestockNarcoticMedicationRequest {
    amount!: number;
    comment?: string | null;
    expectedCurrentVersion!: number;

    constructor(data?: IRestockNarcoticMedicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
        }
    }

    static fromJS(data: any): RestockNarcoticMedicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestockNarcoticMedicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        return data;
    }
}

export interface IRestockNarcoticMedicationRequest {
    amount: number;
    comment?: string | null;
    expectedCurrentVersion: number;
}

export class NarcoticControlCountRequest implements INarcoticControlCountRequest {
    quantity!: number;
    comment!: string;
    expectedCurrentVersion!: number;

    constructor(data?: INarcoticControlCountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
        }
    }

    static fromJS(data: any): NarcoticControlCountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticControlCountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        return data;
    }
}

export interface INarcoticControlCountRequest {
    quantity: number;
    comment: string;
    expectedCurrentVersion: number;
}

export class DisposeNarcoticMedicationRequest implements IDisposeNarcoticMedicationRequest {
    amount!: number;
    reason!: string;
    expectedCurrentVersion!: number;

    constructor(data?: IDisposeNarcoticMedicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
        }
    }

    static fromJS(data: any): DisposeNarcoticMedicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisposeNarcoticMedicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        return data;
    }
}

export interface IDisposeNarcoticMedicationRequest {
    amount: number;
    reason: string;
    expectedCurrentVersion: number;
}

export abstract class RecurrencePatternTemplateResponse implements IRecurrencePatternTemplateResponse {
    start!: moment.Moment;
    end?: moment.Moment | null;

    protected _discriminator: string;

    constructor(data?: IRecurrencePatternTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "RecurrencePatternTemplateResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
        }
    }

    static fromJS(data: any): RecurrencePatternTemplateResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DailyRecurrencePatternTemplateResponse") {
            let result = new DailyRecurrencePatternTemplateResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "WeeklyRecurrencePatternTemplateResponse") {
            let result = new WeeklyRecurrencePatternTemplateResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "CyclicDailyRecurrencePatternTemplateResponse") {
            let result = new CyclicDailyRecurrencePatternTemplateResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RecurrencePatternTemplateResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        return data;
    }
}

export interface IRecurrencePatternTemplateResponse {
    start: moment.Moment;
    end?: moment.Moment | null;
}

export class DailyRecurrencePatternTemplateResponse extends RecurrencePatternTemplateResponse implements IDailyRecurrencePatternTemplateResponse {
    plannedAdministrations!: PlannedAdministrationResponse[];
    interval!: number;

    constructor(data?: IDailyRecurrencePatternTemplateResponse) {
        super(data);
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "DailyRecurrencePatternTemplateResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationResponse.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
        }
    }

    static override fromJS(data: any): DailyRecurrencePatternTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRecurrencePatternTemplateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDailyRecurrencePatternTemplateResponse extends IRecurrencePatternTemplateResponse {
    plannedAdministrations: PlannedAdministrationResponse[];
    interval: number;
}

export abstract class PlannedAdministrationResponse implements IPlannedAdministrationResponse {
    plannedTime!: string;

    protected _discriminator: string;

    constructor(data?: IPlannedAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PlannedAdministrationResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.plannedTime = _data["plannedTime"] !== undefined ? _data["plannedTime"] : null as any;
        }
    }

    static fromJS(data: any): PlannedAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AmountPlannedAdministrationResponse") {
            let result = new AmountPlannedAdministrationResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DosageInstructionPlannedAdministrationResponse") {
            let result = new DosageInstructionPlannedAdministrationResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PlannedAdministrationResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["plannedTime"] = this.plannedTime !== undefined ? this.plannedTime : null as any;
        return data;
    }
}

export interface IPlannedAdministrationResponse {
    plannedTime: string;
}

export class AmountPlannedAdministrationResponse extends PlannedAdministrationResponse implements IAmountPlannedAdministrationResponse {
    amount!: number;

    constructor(data?: IAmountPlannedAdministrationResponse) {
        super(data);
        this._discriminator = "AmountPlannedAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static override fromJS(data: any): AmountPlannedAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AmountPlannedAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmountPlannedAdministrationResponse extends IPlannedAdministrationResponse {
    amount: number;
}

export class DosageInstructionPlannedAdministrationResponse extends PlannedAdministrationResponse implements IDosageInstructionPlannedAdministrationResponse {

    constructor(data?: IDosageInstructionPlannedAdministrationResponse) {
        super(data);
        this._discriminator = "DosageInstructionPlannedAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DosageInstructionPlannedAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageInstructionPlannedAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDosageInstructionPlannedAdministrationResponse extends IPlannedAdministrationResponse {
}

export class WeeklyRecurrencePatternTemplateResponse extends RecurrencePatternTemplateResponse implements IWeeklyRecurrencePatternTemplateResponse {
    weekAdministrations!: DayOfWeekAdministrationsResponse[];
    interval!: number;

    constructor(data?: IWeeklyRecurrencePatternTemplateResponse) {
        super(data);
        if (!data) {
            this.weekAdministrations = [];
        }
        this._discriminator = "WeeklyRecurrencePatternTemplateResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["weekAdministrations"])) {
                this.weekAdministrations = [] as any;
                for (let item of _data["weekAdministrations"])
                    this.weekAdministrations!.push(DayOfWeekAdministrationsResponse.fromJS(item));
            }
            else {
                this.weekAdministrations = null as any;
            }
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
        }
    }

    static override fromJS(data: any): WeeklyRecurrencePatternTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRecurrencePatternTemplateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weekAdministrations)) {
            data["weekAdministrations"] = [];
            for (let item of this.weekAdministrations)
                data["weekAdministrations"].push(item ? item.toJSON() : null as any);
        }
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWeeklyRecurrencePatternTemplateResponse extends IRecurrencePatternTemplateResponse {
    weekAdministrations: DayOfWeekAdministrationsResponse[];
    interval: number;
}

export class DayOfWeekAdministrationsResponse implements IDayOfWeekAdministrationsResponse {
    dayOfWeek!: IsoDayOfWeek;
    plannedAdministrations!: PlannedAdministrationResponse[];

    constructor(data?: IDayOfWeekAdministrationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plannedAdministrations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"] !== undefined ? _data["dayOfWeek"] : null as any;
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationResponse.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
        }
    }

    static fromJS(data: any): DayOfWeekAdministrationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DayOfWeekAdministrationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek !== undefined ? this.dayOfWeek : null as any;
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDayOfWeekAdministrationsResponse {
    dayOfWeek: IsoDayOfWeek;
    plannedAdministrations: PlannedAdministrationResponse[];
}

export enum IsoDayOfWeek {
    None = "None",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export class CyclicDailyRecurrencePatternTemplateResponse extends RecurrencePatternTemplateResponse implements ICyclicDailyRecurrencePatternTemplateResponse {
    subsequences!: SubsequenceTemplateResponse[];

    constructor(data?: ICyclicDailyRecurrencePatternTemplateResponse) {
        super(data);
        if (!data) {
            this.subsequences = [];
        }
        this._discriminator = "CyclicDailyRecurrencePatternTemplateResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["subsequences"])) {
                this.subsequences = [] as any;
                for (let item of _data["subsequences"])
                    this.subsequences!.push(SubsequenceTemplateResponse.fromJS(item));
            }
            else {
                this.subsequences = null as any;
            }
        }
    }

    static override fromJS(data: any): CyclicDailyRecurrencePatternTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CyclicDailyRecurrencePatternTemplateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subsequences)) {
            data["subsequences"] = [];
            for (let item of this.subsequences)
                data["subsequences"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICyclicDailyRecurrencePatternTemplateResponse extends IRecurrencePatternTemplateResponse {
    subsequences: SubsequenceTemplateResponse[];
}

export abstract class SubsequenceTemplateResponse implements ISubsequenceTemplateResponse {
    order!: number;
    numberOfDays!: number;

    protected _discriminator: string;

    constructor(data?: ISubsequenceTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SubsequenceTemplateResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.numberOfDays = _data["numberOfDays"] !== undefined ? _data["numberOfDays"] : null as any;
        }
    }

    static fromJS(data: any): SubsequenceTemplateResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "SubsequenceTemplatePauseResponse") {
            let result = new SubsequenceTemplatePauseResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SubsequenceTemplateWithAdministrationsResponse") {
            let result = new SubsequenceTemplateWithAdministrationsResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SubsequenceTemplateResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["numberOfDays"] = this.numberOfDays !== undefined ? this.numberOfDays : null as any;
        return data;
    }
}

export interface ISubsequenceTemplateResponse {
    order: number;
    numberOfDays: number;
}

export class SubsequenceTemplatePauseResponse extends SubsequenceTemplateResponse implements ISubsequenceTemplatePauseResponse {

    constructor(data?: ISubsequenceTemplatePauseResponse) {
        super(data);
        this._discriminator = "SubsequenceTemplatePauseResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubsequenceTemplatePauseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubsequenceTemplatePauseResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubsequenceTemplatePauseResponse extends ISubsequenceTemplateResponse {
}

export class SubsequenceTemplateWithAdministrationsResponse extends SubsequenceTemplateResponse implements ISubsequenceTemplateWithAdministrationsResponse {
    plannedAdministrations!: PlannedAdministrationResponse[];

    constructor(data?: ISubsequenceTemplateWithAdministrationsResponse) {
        super(data);
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "SubsequenceTemplateWithAdministrationsResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationResponse.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
        }
    }

    static override fromJS(data: any): SubsequenceTemplateWithAdministrationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubsequenceTemplateWithAdministrationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubsequenceTemplateWithAdministrationsResponse extends ISubsequenceTemplateResponse {
    plannedAdministrations: PlannedAdministrationResponse[];
}

export class RecurrencePatternTemplatesForDosageInstructionsRequest implements IRecurrencePatternTemplatesForDosageInstructionsRequest {
    isDosePackaging!: boolean;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    dosageInstructions!: DosageInstructionDto[];

    constructor(data?: IRecurrencePatternTemplatesForDosageInstructionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dosageInstructions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDosePackaging = _data["isDosePackaging"] !== undefined ? _data["isDosePackaging"] : null as any;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : null as any;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : null as any;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = null as any;
            }
        }
    }

    static fromJS(data: any): RecurrencePatternTemplatesForDosageInstructionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecurrencePatternTemplatesForDosageInstructionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDosePackaging"] = this.isDosePackaging !== undefined ? this.isDosePackaging : null as any;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : null as any;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : null as any;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IRecurrencePatternTemplatesForDosageInstructionsRequest {
    isDosePackaging: boolean;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    dosageInstructions: DosageInstructionDto[];
}

export class DosageInstructionDto implements IDosageInstructionDto {
    text!: string;
    asNeeded?: boolean | null;
    administeringInstruction?: string | null;
    additionalInstruction?: string | null;
    observandumDose?: boolean | null;
    sequence!: number;
    subSequence?: number | null;
    dosageType?: string | null;
    patientInstruction!: string;
    maxDosePerPeriod?: DosageMaxDosePerPeriodDto | null;
    method?: DosageMethodDto | null;
    site?: DosageSiteDto | null;
    siteQualifier?: DosageSiteQualifierDto | null;
    timing?: DosageTimingDto | null;
    doseAndRate?: DosageDoseAndRateDto | null;
    route?: DosageRouteDto | null;
    medicalDevice?: DosageMedicalDeviceDto | null;

    constructor(data?: IDosageInstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.asNeeded = _data["asNeeded"] !== undefined ? _data["asNeeded"] : null as any;
            this.administeringInstruction = _data["administeringInstruction"] !== undefined ? _data["administeringInstruction"] : null as any;
            this.additionalInstruction = _data["additionalInstruction"] !== undefined ? _data["additionalInstruction"] : null as any;
            this.observandumDose = _data["observandumDose"] !== undefined ? _data["observandumDose"] : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.subSequence = _data["subSequence"] !== undefined ? _data["subSequence"] : null as any;
            this.dosageType = _data["dosageType"] !== undefined ? _data["dosageType"] : null as any;
            this.patientInstruction = _data["patientInstruction"] !== undefined ? _data["patientInstruction"] : null as any;
            this.maxDosePerPeriod = _data["maxDosePerPeriod"] ? DosageMaxDosePerPeriodDto.fromJS(_data["maxDosePerPeriod"]) : null as any;
            this.method = _data["method"] ? DosageMethodDto.fromJS(_data["method"]) : null as any;
            this.site = _data["site"] ? DosageSiteDto.fromJS(_data["site"]) : null as any;
            this.siteQualifier = _data["siteQualifier"] ? DosageSiteQualifierDto.fromJS(_data["siteQualifier"]) : null as any;
            this.timing = _data["timing"] ? DosageTimingDto.fromJS(_data["timing"]) : null as any;
            this.doseAndRate = _data["doseAndRate"] ? DosageDoseAndRateDto.fromJS(_data["doseAndRate"]) : null as any;
            this.route = _data["route"] ? DosageRouteDto.fromJS(_data["route"]) : null as any;
            this.medicalDevice = _data["medicalDevice"] ? DosageMedicalDeviceDto.fromJS(_data["medicalDevice"]) : null as any;
        }
    }

    static fromJS(data: any): DosageInstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageInstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["asNeeded"] = this.asNeeded !== undefined ? this.asNeeded : null as any;
        data["administeringInstruction"] = this.administeringInstruction !== undefined ? this.administeringInstruction : null as any;
        data["additionalInstruction"] = this.additionalInstruction !== undefined ? this.additionalInstruction : null as any;
        data["observandumDose"] = this.observandumDose !== undefined ? this.observandumDose : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["subSequence"] = this.subSequence !== undefined ? this.subSequence : null as any;
        data["dosageType"] = this.dosageType !== undefined ? this.dosageType : null as any;
        data["patientInstruction"] = this.patientInstruction !== undefined ? this.patientInstruction : null as any;
        data["maxDosePerPeriod"] = this.maxDosePerPeriod ? this.maxDosePerPeriod.toJSON() : null as any;
        data["method"] = this.method ? this.method.toJSON() : null as any;
        data["site"] = this.site ? this.site.toJSON() : null as any;
        data["siteQualifier"] = this.siteQualifier ? this.siteQualifier.toJSON() : null as any;
        data["timing"] = this.timing ? this.timing.toJSON() : null as any;
        data["doseAndRate"] = this.doseAndRate ? this.doseAndRate.toJSON() : null as any;
        data["route"] = this.route ? this.route.toJSON() : null as any;
        data["medicalDevice"] = this.medicalDevice ? this.medicalDevice.toJSON() : null as any;
        return data;
    }
}

export interface IDosageInstructionDto {
    text: string;
    asNeeded?: boolean | null;
    administeringInstruction?: string | null;
    additionalInstruction?: string | null;
    observandumDose?: boolean | null;
    sequence: number;
    subSequence?: number | null;
    dosageType?: string | null;
    patientInstruction: string;
    maxDosePerPeriod?: DosageMaxDosePerPeriodDto | null;
    method?: DosageMethodDto | null;
    site?: DosageSiteDto | null;
    siteQualifier?: DosageSiteQualifierDto | null;
    timing?: DosageTimingDto | null;
    doseAndRate?: DosageDoseAndRateDto | null;
    route?: DosageRouteDto | null;
    medicalDevice?: DosageMedicalDeviceDto | null;
}

export class DosageMaxDosePerPeriodDto implements IDosageMaxDosePerPeriodDto {
    doseValue?: number | null;
    doseUnit?: string | null;
    dosePeriod?: number | null;
    dosePeriodUnit?: string | null;

    constructor(data?: IDosageMaxDosePerPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doseValue = _data["doseValue"] !== undefined ? _data["doseValue"] : null as any;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
            this.dosePeriod = _data["dosePeriod"] !== undefined ? _data["dosePeriod"] : null as any;
            this.dosePeriodUnit = _data["dosePeriodUnit"] !== undefined ? _data["dosePeriodUnit"] : null as any;
        }
    }

    static fromJS(data: any): DosageMaxDosePerPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMaxDosePerPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doseValue"] = this.doseValue !== undefined ? this.doseValue : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        data["dosePeriod"] = this.dosePeriod !== undefined ? this.dosePeriod : null as any;
        data["dosePeriodUnit"] = this.dosePeriodUnit !== undefined ? this.dosePeriodUnit : null as any;
        return data;
    }
}

export interface IDosageMaxDosePerPeriodDto {
    doseValue?: number | null;
    doseUnit?: string | null;
    dosePeriod?: number | null;
    dosePeriodUnit?: string | null;
}

export class DosageMethodDto implements IDosageMethodDto {
    method!: string;
    otherMethodDescription?: string | null;

    constructor(data?: IDosageMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"] !== undefined ? _data["method"] : null as any;
            this.otherMethodDescription = _data["otherMethodDescription"] !== undefined ? _data["otherMethodDescription"] : null as any;
        }
    }

    static fromJS(data: any): DosageMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : null as any;
        data["otherMethodDescription"] = this.otherMethodDescription !== undefined ? this.otherMethodDescription : null as any;
        return data;
    }
}

export interface IDosageMethodDto {
    method: string;
    otherMethodDescription?: string | null;
}

export class DosageSiteDto implements IDosageSiteDto {
    site!: string;
    otherSiteDescription?: string | null;

    constructor(data?: IDosageSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] !== undefined ? _data["site"] : null as any;
            this.otherSiteDescription = _data["otherSiteDescription"] !== undefined ? _data["otherSiteDescription"] : null as any;
        }
    }

    static fromJS(data: any): DosageSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site !== undefined ? this.site : null as any;
        data["otherSiteDescription"] = this.otherSiteDescription !== undefined ? this.otherSiteDescription : null as any;
        return data;
    }
}

export interface IDosageSiteDto {
    site: string;
    otherSiteDescription?: string | null;
}

export class DosageSiteQualifierDto implements IDosageSiteQualifierDto {
    siteQualifier!: string;
    otherSiteQualifierDescription?: string | null;

    constructor(data?: IDosageSiteQualifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteQualifier = _data["siteQualifier"] !== undefined ? _data["siteQualifier"] : null as any;
            this.otherSiteQualifierDescription = _data["otherSiteQualifierDescription"] !== undefined ? _data["otherSiteQualifierDescription"] : null as any;
        }
    }

    static fromJS(data: any): DosageSiteQualifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageSiteQualifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteQualifier"] = this.siteQualifier !== undefined ? this.siteQualifier : null as any;
        data["otherSiteQualifierDescription"] = this.otherSiteQualifierDescription !== undefined ? this.otherSiteQualifierDescription : null as any;
        return data;
    }
}

export interface IDosageSiteQualifierDto {
    siteQualifier: string;
    otherSiteQualifierDescription?: string | null;
}

export class DosageTimingDto implements IDosageTimingDto {
    bounds?: DosageBoundsDto | null;
    duration?: number | null;
    durationUnit?: string | null;
    subSequenceDuration?: number | null;
    subSequenceDurationUnit?: string | null;
    daysOfWeek!: DayOfWeek[];
    periodsOfDay!: string[];
    timesOfDay!: string[];

    constructor(data?: IDosageTimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.daysOfWeek = [];
            this.periodsOfDay = [];
            this.timesOfDay = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bounds = _data["bounds"] ? DosageBoundsDto.fromJS(_data["bounds"]) : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.durationUnit = _data["durationUnit"] !== undefined ? _data["durationUnit"] : null as any;
            this.subSequenceDuration = _data["subSequenceDuration"] !== undefined ? _data["subSequenceDuration"] : null as any;
            this.subSequenceDurationUnit = _data["subSequenceDurationUnit"] !== undefined ? _data["subSequenceDurationUnit"] : null as any;
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            else {
                this.daysOfWeek = null as any;
            }
            if (Array.isArray(_data["periodsOfDay"])) {
                this.periodsOfDay = [] as any;
                for (let item of _data["periodsOfDay"])
                    this.periodsOfDay!.push(item);
            }
            else {
                this.periodsOfDay = null as any;
            }
            if (Array.isArray(_data["timesOfDay"])) {
                this.timesOfDay = [] as any;
                for (let item of _data["timesOfDay"])
                    this.timesOfDay!.push(item);
            }
            else {
                this.timesOfDay = null as any;
            }
        }
    }

    static fromJS(data: any): DosageTimingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageTimingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bounds"] = this.bounds ? this.bounds.toJSON() : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["durationUnit"] = this.durationUnit !== undefined ? this.durationUnit : null as any;
        data["subSequenceDuration"] = this.subSequenceDuration !== undefined ? this.subSequenceDuration : null as any;
        data["subSequenceDurationUnit"] = this.subSequenceDurationUnit !== undefined ? this.subSequenceDurationUnit : null as any;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        if (Array.isArray(this.periodsOfDay)) {
            data["periodsOfDay"] = [];
            for (let item of this.periodsOfDay)
                data["periodsOfDay"].push(item);
        }
        if (Array.isArray(this.timesOfDay)) {
            data["timesOfDay"] = [];
            for (let item of this.timesOfDay)
                data["timesOfDay"].push(item);
        }
        return data;
    }
}

export interface IDosageTimingDto {
    bounds?: DosageBoundsDto | null;
    duration?: number | null;
    durationUnit?: string | null;
    subSequenceDuration?: number | null;
    subSequenceDurationUnit?: string | null;
    daysOfWeek: DayOfWeek[];
    periodsOfDay: string[];
    timesOfDay: string[];
}

export abstract class DosageBoundsDto implements IDosageBoundsDto {

    protected _discriminator: string;

    constructor(data?: IDosageBoundsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "DosageBoundsDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DosageBoundsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "BoundsDurationDto") {
            let result = new BoundsDurationDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoundsRangeDto") {
            let result = new BoundsRangeDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DosageBoundsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface IDosageBoundsDto {
}

export class BoundsDurationDto extends DosageBoundsDto implements IBoundsDurationDto {
    value!: number;
    unit!: string;

    constructor(data?: IBoundsDurationDto) {
        super(data);
        this._discriminator = "BoundsDurationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
        }
    }

    static override fromJS(data: any): BoundsDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoundsDurationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBoundsDurationDto extends IDosageBoundsDto {
    value: number;
    unit: string;
}

export class BoundsRangeDto extends DosageBoundsDto implements IBoundsRangeDto {
    minValue!: number;
    maxValue!: number;
    minUnit!: string;
    maxUnit!: string;

    constructor(data?: IBoundsRangeDto) {
        super(data);
        this._discriminator = "BoundsRangeDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null as any;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null as any;
            this.minUnit = _data["minUnit"] !== undefined ? _data["minUnit"] : null as any;
            this.maxUnit = _data["maxUnit"] !== undefined ? _data["maxUnit"] : null as any;
        }
    }

    static override fromJS(data: any): BoundsRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoundsRangeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : null as any;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null as any;
        data["minUnit"] = this.minUnit !== undefined ? this.minUnit : null as any;
        data["maxUnit"] = this.maxUnit !== undefined ? this.maxUnit : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBoundsRangeDto extends IDosageBoundsDto {
    minValue: number;
    maxValue: number;
    minUnit: string;
    maxUnit: string;
}

export enum DayOfWeek {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export class DosageDoseAndRateDto implements IDosageDoseAndRateDto {
    rate?: DosageRateDto | null;
    dose?: DosageDoseDto | null;

    constructor(data?: IDosageDoseAndRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] ? DosageRateDto.fromJS(_data["rate"]) : null as any;
            this.dose = _data["dose"] ? DosageDoseDto.fromJS(_data["dose"]) : null as any;
        }
    }

    static fromJS(data: any): DosageDoseAndRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseAndRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate ? this.rate.toJSON() : null as any;
        data["dose"] = this.dose ? this.dose.toJSON() : null as any;
        return data;
    }
}

export interface IDosageDoseAndRateDto {
    rate?: DosageRateDto | null;
    dose?: DosageDoseDto | null;
}

export class DosageRateDto implements IDosageRateDto {
    value?: number | null;
    unit!: string;

    constructor(data?: IDosageRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
        }
    }

    static fromJS(data: any): DosageRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        return data;
    }
}

export interface IDosageRateDto {
    value?: number | null;
    unit: string;
}

export abstract class DosageDoseDto implements IDosageDoseDto {

    protected _discriminator: string;

    constructor(data?: IDosageDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "DosageDoseDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DosageDoseDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DosageDoseRangeDto") {
            let result = new DosageDoseRangeDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DosageDoseQuantityDto") {
            let result = new DosageDoseQuantityDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DosageDoseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface IDosageDoseDto {
}

export class DosageDoseRangeDto extends DosageDoseDto implements IDosageDoseRangeDto {
    minValue!: number;
    maxValue!: number;
    minUnit!: string;
    maxUnit!: string;

    constructor(data?: IDosageDoseRangeDto) {
        super(data);
        this._discriminator = "DosageDoseRangeDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null as any;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null as any;
            this.minUnit = _data["minUnit"] !== undefined ? _data["minUnit"] : null as any;
            this.maxUnit = _data["maxUnit"] !== undefined ? _data["maxUnit"] : null as any;
        }
    }

    static override fromJS(data: any): DosageDoseRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseRangeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : null as any;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null as any;
        data["minUnit"] = this.minUnit !== undefined ? this.minUnit : null as any;
        data["maxUnit"] = this.maxUnit !== undefined ? this.maxUnit : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageDoseRangeDto extends IDosageDoseDto {
    minValue: number;
    maxValue: number;
    minUnit: string;
    maxUnit: string;
}

export class DosageDoseQuantityDto extends DosageDoseDto implements IDosageDoseQuantityDto {
    value?: number | null;
    unit?: string | null;

    constructor(data?: IDosageDoseQuantityDto) {
        super(data);
        this._discriminator = "DosageDoseQuantityDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
        }
    }

    static override fromJS(data: any): DosageDoseQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseQuantityDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageDoseQuantityDto extends IDosageDoseDto {
    value?: number | null;
    unit?: string | null;
}

export class DosageRouteDto implements IDosageRouteDto {
    code!: string;
    route!: string;
    otherRouteDescription?: string | null;

    constructor(data?: IDosageRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.route = _data["route"] !== undefined ? _data["route"] : null as any;
            this.otherRouteDescription = _data["otherRouteDescription"] !== undefined ? _data["otherRouteDescription"] : null as any;
        }
    }

    static fromJS(data: any): DosageRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["route"] = this.route !== undefined ? this.route : null as any;
        data["otherRouteDescription"] = this.otherRouteDescription !== undefined ? this.otherRouteDescription : null as any;
        return data;
    }
}

export interface IDosageRouteDto {
    code: string;
    route: string;
    otherRouteDescription?: string | null;
}

export class DosageMedicalDeviceDto implements IDosageMedicalDeviceDto {
    otherDescription?: string | null;
    displayText?: string | null;

    constructor(data?: IDosageMedicalDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otherDescription = _data["otherDescription"] !== undefined ? _data["otherDescription"] : null as any;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : null as any;
        }
    }

    static fromJS(data: any): DosageMedicalDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMedicalDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otherDescription"] = this.otherDescription !== undefined ? this.otherDescription : null as any;
        data["displayText"] = this.displayText !== undefined ? this.displayText : null as any;
        return data;
    }
}

export interface IDosageMedicalDeviceDto {
    otherDescription?: string | null;
    displayText?: string | null;
}

export class AddRecurrencePatternRequest implements IAddRecurrencePatternRequest {
    recurrencePattern!: RecurrencePatternRequest;

    constructor(data?: IAddRecurrencePatternRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurrencePattern = _data["recurrencePattern"] ? RecurrencePatternRequest.fromJS(_data["recurrencePattern"]) : null as any;
        }
    }

    static fromJS(data: any): AddRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrencePattern"] = this.recurrencePattern ? this.recurrencePattern.toJSON() : null as any;
        return data;
    }
}

export interface IAddRecurrencePatternRequest {
    recurrencePattern: RecurrencePatternRequest;
}

export abstract class RecurrencePatternRequest implements IRecurrencePatternRequest {
    start!: moment.Moment;
    end?: moment.Moment | null;
    dispensedMedication!: boolean;

    protected _discriminator: string;

    constructor(data?: IRecurrencePatternRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "RecurrencePatternRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
            this.dispensedMedication = _data["dispensedMedication"] !== undefined ? _data["dispensedMedication"] : null as any;
        }
    }

    static fromJS(data: any): RecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DailyRecurrencePatternRequest") {
            let result = new DailyRecurrencePatternRequest();
            result.init(data);
            return result;
        }
        if (data["$type"] === "WeeklyRecurrencePatternRequest") {
            let result = new WeeklyRecurrencePatternRequest();
            result.init(data);
            return result;
        }
        if (data["$type"] === "CyclicDailyRecurrencePatternRequest") {
            let result = new CyclicDailyRecurrencePatternRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RecurrencePatternRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        data["dispensedMedication"] = this.dispensedMedication !== undefined ? this.dispensedMedication : null as any;
        return data;
    }
}

export interface IRecurrencePatternRequest {
    start: moment.Moment;
    end?: moment.Moment | null;
    dispensedMedication: boolean;
}

export class DailyRecurrencePatternRequest extends RecurrencePatternRequest implements IDailyRecurrencePatternRequest {
    interval!: number;
    plannedAdministrations!: PlannedAdministrationRequest[];

    constructor(data?: IDailyRecurrencePatternRequest) {
        super(data);
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "DailyRecurrencePatternRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationRequest.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
        }
    }

    static override fromJS(data: any): DailyRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDailyRecurrencePatternRequest extends IRecurrencePatternRequest {
    interval: number;
    plannedAdministrations: PlannedAdministrationRequest[];
}

export abstract class PlannedAdministrationRequest implements IPlannedAdministrationRequest {
    plannedTime!: string;

    protected _discriminator: string;

    constructor(data?: IPlannedAdministrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PlannedAdministrationRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.plannedTime = _data["plannedTime"] !== undefined ? _data["plannedTime"] : null as any;
        }
    }

    static fromJS(data: any): PlannedAdministrationRequest {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AmountPlannedAdministrationRequest") {
            let result = new AmountPlannedAdministrationRequest();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DosageInstructionPlannedAdministrationRequest") {
            let result = new DosageInstructionPlannedAdministrationRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PlannedAdministrationRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["plannedTime"] = this.plannedTime !== undefined ? this.plannedTime : null as any;
        return data;
    }
}

export interface IPlannedAdministrationRequest {
    plannedTime: string;
}

export class AmountPlannedAdministrationRequest extends PlannedAdministrationRequest implements IAmountPlannedAdministrationRequest {
    amount!: number;

    constructor(data?: IAmountPlannedAdministrationRequest) {
        super(data);
        this._discriminator = "AmountPlannedAdministrationRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static override fromJS(data: any): AmountPlannedAdministrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AmountPlannedAdministrationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmountPlannedAdministrationRequest extends IPlannedAdministrationRequest {
    amount: number;
}

export class DosageInstructionPlannedAdministrationRequest extends PlannedAdministrationRequest implements IDosageInstructionPlannedAdministrationRequest {

    constructor(data?: IDosageInstructionPlannedAdministrationRequest) {
        super(data);
        this._discriminator = "DosageInstructionPlannedAdministrationRequest";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DosageInstructionPlannedAdministrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DosageInstructionPlannedAdministrationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDosageInstructionPlannedAdministrationRequest extends IPlannedAdministrationRequest {
}

export class WeeklyRecurrencePatternRequest extends RecurrencePatternRequest implements IWeeklyRecurrencePatternRequest {
    weekAdministrations!: DayOfWeekAdministrationsRequest[];
    interval!: number;

    constructor(data?: IWeeklyRecurrencePatternRequest) {
        super(data);
        if (!data) {
            this.weekAdministrations = [];
        }
        this._discriminator = "WeeklyRecurrencePatternRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["weekAdministrations"])) {
                this.weekAdministrations = [] as any;
                for (let item of _data["weekAdministrations"])
                    this.weekAdministrations!.push(DayOfWeekAdministrationsRequest.fromJS(item));
            }
            else {
                this.weekAdministrations = null as any;
            }
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
        }
    }

    static override fromJS(data: any): WeeklyRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weekAdministrations)) {
            data["weekAdministrations"] = [];
            for (let item of this.weekAdministrations)
                data["weekAdministrations"].push(item ? item.toJSON() : null as any);
        }
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWeeklyRecurrencePatternRequest extends IRecurrencePatternRequest {
    weekAdministrations: DayOfWeekAdministrationsRequest[];
    interval: number;
}

export class DayOfWeekAdministrationsRequest implements IDayOfWeekAdministrationsRequest {
    dayOfWeek!: string;
    plannedAdministrations!: PlannedAdministrationRequest[];

    constructor(data?: IDayOfWeekAdministrationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plannedAdministrations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"] !== undefined ? _data["dayOfWeek"] : null as any;
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationRequest.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
        }
    }

    static fromJS(data: any): DayOfWeekAdministrationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DayOfWeekAdministrationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek !== undefined ? this.dayOfWeek : null as any;
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDayOfWeekAdministrationsRequest {
    dayOfWeek: string;
    plannedAdministrations: PlannedAdministrationRequest[];
}

export class CyclicDailyRecurrencePatternRequest extends RecurrencePatternRequest implements ICyclicDailyRecurrencePatternRequest {
    subsequences!: SubsequenceRequest[];

    constructor(data?: ICyclicDailyRecurrencePatternRequest) {
        super(data);
        if (!data) {
            this.subsequences = [];
        }
        this._discriminator = "CyclicDailyRecurrencePatternRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["subsequences"])) {
                this.subsequences = [] as any;
                for (let item of _data["subsequences"])
                    this.subsequences!.push(SubsequenceRequest.fromJS(item));
            }
            else {
                this.subsequences = null as any;
            }
        }
    }

    static override fromJS(data: any): CyclicDailyRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CyclicDailyRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subsequences)) {
            data["subsequences"] = [];
            for (let item of this.subsequences)
                data["subsequences"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICyclicDailyRecurrencePatternRequest extends IRecurrencePatternRequest {
    subsequences: SubsequenceRequest[];
}

export abstract class SubsequenceRequest implements ISubsequenceRequest {
    order!: number;
    numberOfDays!: number;

    protected _discriminator: string;

    constructor(data?: ISubsequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SubsequenceRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.numberOfDays = _data["numberOfDays"] !== undefined ? _data["numberOfDays"] : null as any;
        }
    }

    static fromJS(data: any): SubsequenceRequest {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "SubsequencePauseRequest") {
            let result = new SubsequencePauseRequest();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SubsequenceWithAdministrationsRequest") {
            let result = new SubsequenceWithAdministrationsRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SubsequenceRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["numberOfDays"] = this.numberOfDays !== undefined ? this.numberOfDays : null as any;
        return data;
    }
}

export interface ISubsequenceRequest {
    order: number;
    numberOfDays: number;
}

export class SubsequencePauseRequest extends SubsequenceRequest implements ISubsequencePauseRequest {

    constructor(data?: ISubsequencePauseRequest) {
        super(data);
        this._discriminator = "SubsequencePauseRequest";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubsequencePauseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubsequencePauseRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubsequencePauseRequest extends ISubsequenceRequest {
}

export class SubsequenceWithAdministrationsRequest extends SubsequenceRequest implements ISubsequenceWithAdministrationsRequest {
    plannedAdministrations!: PlannedAdministrationRequest[];

    constructor(data?: ISubsequenceWithAdministrationsRequest) {
        super(data);
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "SubsequenceWithAdministrationsRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationRequest.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
        }
    }

    static override fromJS(data: any): SubsequenceWithAdministrationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubsequenceWithAdministrationsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubsequenceWithAdministrationsRequest extends ISubsequenceRequest {
    plannedAdministrations: PlannedAdministrationRequest[];
}

export class UpdateRecurrencePatternRequest implements IUpdateRecurrencePatternRequest {
    recurrencePattern!: RecurrencePatternRequest;

    constructor(data?: IUpdateRecurrencePatternRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurrencePattern = _data["recurrencePattern"] ? RecurrencePatternRequest.fromJS(_data["recurrencePattern"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrencePattern"] = this.recurrencePattern ? this.recurrencePattern.toJSON() : null as any;
        return data;
    }
}

export interface IUpdateRecurrencePatternRequest {
    recurrencePattern: RecurrencePatternRequest;
}

export class DifferenceResponse implements IDifferenceResponse {
    propertyName!: string;

    protected _discriminator: string;

    constructor(data?: IDifferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "DifferenceResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
        }
    }

    static fromJS(data: any): DifferenceResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "EnumDifferenceResponse") {
            let result = new EnumDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "EnumListDifferenceResponse") {
            let result = new EnumListDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ObjectDifferenceResponse") {
            let result = new ObjectDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ObjectListDifferenceResponse") {
            let result = new ObjectListDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeDifferenceResponse") {
            let result = new SimpleTypeDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeListDifferenceResponse") {
            let result = new SimpleTypeListDifferenceResponse();
            result.init(data);
            return result;
        }
        let result = new DifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        return data;
    }
}

export interface IDifferenceResponse {
    propertyName: string;
}

export class EnumDifferenceResponse extends DifferenceResponse implements IEnumDifferenceResponse {
    enumName!: string;
    from?: any | null;
    to?: any | null;

    constructor(data?: IEnumDifferenceResponse) {
        super(data);
        this._discriminator = "EnumDifferenceResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): EnumDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDifferenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnumDifferenceResponse extends IDifferenceResponse {
    enumName: string;
    from?: any | null;
    to?: any | null;
}

export class EnumListDifferenceResponse extends DifferenceResponse implements IEnumListDifferenceResponse {
    enumName!: string;
    from!: any[];
    to!: any[];

    constructor(data?: IEnumListDifferenceResponse) {
        super(data);
        if (!data) {
            this.from = [];
            this.to = [];
        }
        this._discriminator = "EnumListDifferenceResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : null as any;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(item);
            }
            else {
                this.from = null as any;
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            else {
                this.to = null as any;
            }
        }
    }

    static override fromJS(data: any): EnumListDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListDifferenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : null as any;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEnumListDifferenceResponse extends IDifferenceResponse {
    enumName: string;
    from: any[];
    to: any[];
}

export class ObjectDifferenceResponse extends DifferenceResponse implements IObjectDifferenceResponse {
    differences!: DifferenceResponse[];

    constructor(data?: IObjectDifferenceResponse) {
        super(data);
        if (!data) {
            this.differences = [];
        }
        this._discriminator = "ObjectDifferenceResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["differences"])) {
                this.differences = [] as any;
                for (let item of _data["differences"])
                    this.differences!.push(DifferenceResponse.fromJS(item));
            }
            else {
                this.differences = null as any;
            }
        }
    }

    static override fromJS(data: any): ObjectDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectDifferenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectDifferenceResponse extends IDifferenceResponse {
    differences: DifferenceResponse[];
}

export class ObjectListDifferenceResponse extends DifferenceResponse implements IObjectListDifferenceResponse {
    propertyType!: PropertyType;
    from!: ObjectListValueResponse[];
    to!: ObjectListValueResponse[];

    constructor(data?: IObjectListDifferenceResponse) {
        super(data);
        if (!data) {
            this.from = [];
            this.to = [];
        }
        this._discriminator = "ObjectListDifferenceResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : null as any;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(ObjectListValueResponse.fromJS(item));
            }
            else {
                this.from = null as any;
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(ObjectListValueResponse.fromJS(item));
            }
            else {
                this.to = null as any;
            }
        }
    }

    static override fromJS(data: any): ObjectListDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectListDifferenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectListDifferenceResponse extends IDifferenceResponse {
    propertyType: PropertyType;
    from: ObjectListValueResponse[];
    to: ObjectListValueResponse[];
}

export enum PropertyType {
    SimpleType = "SimpleType",
    Object = "Object",
    SimpleTypeList = "SimpleTypeList",
    ObjectList = "ObjectList",
    Enum = "Enum",
    EnumList = "EnumList",
}

export class ObjectListValueResponse implements IObjectListValueResponse {
    objectProperties!: ObjectListItemResponse[];

    constructor(data?: IObjectListValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.objectProperties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objectProperties"])) {
                this.objectProperties = [] as any;
                for (let item of _data["objectProperties"])
                    this.objectProperties!.push(ObjectListItemResponse.fromJS(item));
            }
            else {
                this.objectProperties = null as any;
            }
        }
    }

    static fromJS(data: any): ObjectListValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectListValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objectProperties)) {
            data["objectProperties"] = [];
            for (let item of this.objectProperties)
                data["objectProperties"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IObjectListValueResponse {
    objectProperties: ObjectListItemResponse[];
}

export abstract class ObjectListItemResponse implements IObjectListItemResponse {
    propertyName!: string;

    protected _discriminator: string;

    constructor(data?: IObjectListItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ObjectListItemResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
        }
    }

    static fromJS(data: any): ObjectListItemResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ObjectValueResponse") {
            let result = new ObjectValueResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeListResponse") {
            let result = new SimpleTypeListResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeValueResponse") {
            let result = new SimpleTypeValueResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ObjectListResponse") {
            let result = new ObjectListResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "EnumListResponse") {
            let result = new EnumListResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "EnumValueResponse") {
            let result = new EnumValueResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ObjectListItemResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        return data;
    }
}

export interface IObjectListItemResponse {
    propertyName: string;
}

export class ObjectValueResponse extends ObjectListItemResponse implements IObjectValueResponse {
    objectProperties!: ObjectListItemResponse[];

    constructor(data?: IObjectValueResponse) {
        super(data);
        if (!data) {
            this.objectProperties = [];
        }
        this._discriminator = "ObjectValueResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["objectProperties"])) {
                this.objectProperties = [] as any;
                for (let item of _data["objectProperties"])
                    this.objectProperties!.push(ObjectListItemResponse.fromJS(item));
            }
            else {
                this.objectProperties = null as any;
            }
        }
    }

    static override fromJS(data: any): ObjectValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectValueResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objectProperties)) {
            data["objectProperties"] = [];
            for (let item of this.objectProperties)
                data["objectProperties"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectValueResponse extends IObjectListItemResponse {
    objectProperties: ObjectListItemResponse[];
}

export class SimpleTypeListResponse extends ObjectListItemResponse implements ISimpleTypeListResponse {
    propertyType!: SimplePropertyType;
    items!: any[];

    constructor(data?: ISimpleTypeListResponse) {
        super(data);
        if (!data) {
            this.items = [];
        }
        this._discriminator = "SimpleTypeListResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            else {
                this.items = null as any;
            }
        }
    }

    static override fromJS(data: any): SimpleTypeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeListResponse extends IObjectListItemResponse {
    propertyType: SimplePropertyType;
    items: any[];
}

export enum SimplePropertyType {
    String = "String",
    Byte = "Byte",
    Bool = "Bool",
    DateAndTime = "DateAndTime",
    Time = "Time",
    Date = "Date",
    Number = "Number",
    Decimal = "Decimal",
}

export class SimpleTypeValueResponse extends ObjectListItemResponse implements ISimpleTypeValueResponse {
    propertyType!: SimplePropertyType;
    propertyValue?: any | null;

    constructor(data?: ISimpleTypeValueResponse) {
        super(data);
        this._discriminator = "SimpleTypeValueResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : null as any;
            this.propertyValue = _data["propertyValue"] !== undefined ? _data["propertyValue"] : null as any;
        }
    }

    static override fromJS(data: any): SimpleTypeValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeValueResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        data["propertyValue"] = this.propertyValue !== undefined ? this.propertyValue : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeValueResponse extends IObjectListItemResponse {
    propertyType: SimplePropertyType;
    propertyValue?: any | null;
}

export class ObjectListResponse extends ObjectListItemResponse implements IObjectListResponse {
    objectValues!: ObjectListValueResponse[];

    constructor(data?: IObjectListResponse) {
        super(data);
        if (!data) {
            this.objectValues = [];
        }
        this._discriminator = "ObjectListResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["objectValues"])) {
                this.objectValues = [] as any;
                for (let item of _data["objectValues"])
                    this.objectValues!.push(ObjectListValueResponse.fromJS(item));
            }
            else {
                this.objectValues = null as any;
            }
        }
    }

    static override fromJS(data: any): ObjectListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objectValues)) {
            data["objectValues"] = [];
            for (let item of this.objectValues)
                data["objectValues"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectListResponse extends IObjectListItemResponse {
    objectValues: ObjectListValueResponse[];
}

export class EnumListResponse extends ObjectListItemResponse implements IEnumListResponse {
    enumName!: string;
    values!: string[];

    constructor(data?: IEnumListResponse) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "EnumListResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : null as any;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            else {
                this.values = null as any;
            }
        }
    }

    static override fromJS(data: any): EnumListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : null as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEnumListResponse extends IObjectListItemResponse {
    enumName: string;
    values: string[];
}

export class EnumValueResponse extends ObjectListItemResponse implements IEnumValueResponse {
    enumName!: string;
    propertyValue?: any | null;

    constructor(data?: IEnumValueResponse) {
        super(data);
        this._discriminator = "EnumValueResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : null as any;
            this.propertyValue = _data["propertyValue"] !== undefined ? _data["propertyValue"] : null as any;
        }
    }

    static override fromJS(data: any): EnumValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : null as any;
        data["propertyValue"] = this.propertyValue !== undefined ? this.propertyValue : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnumValueResponse extends IObjectListItemResponse {
    enumName: string;
    propertyValue?: any | null;
}

export class SimpleTypeDifferenceResponse extends DifferenceResponse implements ISimpleTypeDifferenceResponse {
    propertyType!: SimplePropertyType;
    from?: any | null;
    to?: any | null;

    constructor(data?: ISimpleTypeDifferenceResponse) {
        super(data);
        this._discriminator = "SimpleTypeDifferenceResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): SimpleTypeDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeDifferenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeDifferenceResponse extends IDifferenceResponse {
    propertyType: SimplePropertyType;
    from?: any | null;
    to?: any | null;
}

export class SimpleTypeListDifferenceResponse extends DifferenceResponse implements ISimpleTypeListDifferenceResponse {
    propertyType!: SimplePropertyType;
    from!: any[];
    to!: any[];

    constructor(data?: ISimpleTypeListDifferenceResponse) {
        super(data);
        if (!data) {
            this.from = [];
            this.to = [];
        }
        this._discriminator = "SimpleTypeListDifferenceResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : null as any;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(item);
            }
            else {
                this.from = null as any;
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            else {
                this.to = null as any;
            }
        }
    }

    static override fromJS(data: any): SimpleTypeListDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeListDifferenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeListDifferenceResponse extends IDifferenceResponse {
    propertyType: SimplePropertyType;
    from: any[];
    to: any[];
}

export class CompareWithStoredPrescriptionsRequest implements ICompareWithStoredPrescriptionsRequest {
    prescriptionChainId!: string;
    prescriptions!: PrescriptionDto[];

    constructor(data?: ICompareWithStoredPrescriptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prescriptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            if (Array.isArray(_data["prescriptions"])) {
                this.prescriptions = [] as any;
                for (let item of _data["prescriptions"])
                    this.prescriptions!.push(PrescriptionDto.fromJS(item));
            }
            else {
                this.prescriptions = null as any;
            }
        }
    }

    static fromJS(data: any): CompareWithStoredPrescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompareWithStoredPrescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        if (Array.isArray(this.prescriptions)) {
            data["prescriptions"] = [];
            for (let item of this.prescriptions)
                data["prescriptions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICompareWithStoredPrescriptionsRequest {
    prescriptionChainId: string;
    prescriptions: PrescriptionDto[];
}

export class PrescriptionDto implements IPrescriptionDto {
    id!: string;
    prescriptionChainId!: string;
    version!: number;
    prescriptionFormat!: string;
    isPartOfPrescriptionChain!: boolean;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    medication!: MedicationDto;
    treatmentReason?: string | null;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionDto[];
    practitioner!: PractitionerDto;
    dispenseInformation!: DispenseInformationDto;
    notes!: NoteDto[];
    prescriptionReasons!: PrescriptionReasonDto[];
    medicationDispenses!: MedicationDispenseDto[];

    constructor(data?: IPrescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerDto();
            this.dispenseInformation = new DispenseInformationDto();
            this.notes = [];
            this.prescriptionReasons = [];
            this.medicationDispenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : null as any;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : null as any;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : null as any;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : null as any;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : null as any;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : null as any;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoDto.fromJS(_data["priorityInfo"]) : null as any;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : null as any;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : null as any;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : null as any;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : null as any;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = null as any;
            }
            this.practitioner = _data["practitioner"] ? PractitionerDto.fromJS(_data["practitioner"]) : new PractitionerDto();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationDto.fromJS(_data["dispenseInformation"]) : new DispenseInformationDto();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = null as any;
            }
            if (Array.isArray(_data["medicationDispenses"])) {
                this.medicationDispenses = [] as any;
                for (let item of _data["medicationDispenses"])
                    this.medicationDispenses!.push(MedicationDispenseDto.fromJS(item));
            }
            else {
                this.medicationDispenses = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : null as any;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : null as any;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : null as any;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : null as any;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : null as any;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : null as any;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : null as any;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : null as any;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : null as any;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : null as any;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : null as any;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : null as any);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : null as any;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : null as any;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.medicationDispenses)) {
            data["medicationDispenses"] = [];
            for (let item of this.medicationDispenses)
                data["medicationDispenses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPrescriptionDto {
    id: string;
    prescriptionChainId: string;
    version: number;
    prescriptionFormat: string;
    isPartOfPrescriptionChain: boolean;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    medication: MedicationDto;
    treatmentReason?: string | null;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionDto[];
    practitioner: PractitionerDto;
    dispenseInformation: DispenseInformationDto;
    notes: NoteDto[];
    prescriptionReasons: PrescriptionReasonDto[];
    medicationDispenses: MedicationDispenseDto[];
}

export class MedicationDto implements IMedicationDto {
    nplPackId?: string | null;
    medicalConsumableId?: string | null;
    nplId?: string | null;
    form?: string | null;
    strength?: string | null;
    interchangeSubstanceGroup?: string | null;
    productName?: string | null;
    packageContainer?: string | null;
    packageDescription?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    amountDescription?: string | null;
    packagingUnit?: string | null;
    manufacturerName?: string | null;
    narcoticClassification?: NarcoticClassificationDto | null;

    constructor(data?: IMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplPackId = _data["nplPackId"] !== undefined ? _data["nplPackId"] : null as any;
            this.medicalConsumableId = _data["medicalConsumableId"] !== undefined ? _data["medicalConsumableId"] : null as any;
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.form = _data["form"] !== undefined ? _data["form"] : null as any;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : null as any;
            this.interchangeSubstanceGroup = _data["interchangeSubstanceGroup"] !== undefined ? _data["interchangeSubstanceGroup"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.packageContainer = _data["packageContainer"] !== undefined ? _data["packageContainer"] : null as any;
            this.packageDescription = _data["packageDescription"] !== undefined ? _data["packageDescription"] : null as any;
            this.atcClearText = _data["atcClearText"] !== undefined ? _data["atcClearText"] : null as any;
            this.atcCode = _data["atcCode"] !== undefined ? _data["atcCode"] : null as any;
            this.articleSummaryHtml = _data["articleSummaryHtml"] !== undefined ? _data["articleSummaryHtml"] : null as any;
            this.amountDescription = _data["amountDescription"] !== undefined ? _data["amountDescription"] : null as any;
            this.packagingUnit = _data["packagingUnit"] !== undefined ? _data["packagingUnit"] : null as any;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null as any;
            this.narcoticClassification = _data["narcoticClassification"] ? NarcoticClassificationDto.fromJS(_data["narcoticClassification"]) : null as any;
        }
    }

    static fromJS(data: any): MedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplPackId"] = this.nplPackId !== undefined ? this.nplPackId : null as any;
        data["medicalConsumableId"] = this.medicalConsumableId !== undefined ? this.medicalConsumableId : null as any;
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["form"] = this.form !== undefined ? this.form : null as any;
        data["strength"] = this.strength !== undefined ? this.strength : null as any;
        data["interchangeSubstanceGroup"] = this.interchangeSubstanceGroup !== undefined ? this.interchangeSubstanceGroup : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["packageContainer"] = this.packageContainer !== undefined ? this.packageContainer : null as any;
        data["packageDescription"] = this.packageDescription !== undefined ? this.packageDescription : null as any;
        data["atcClearText"] = this.atcClearText !== undefined ? this.atcClearText : null as any;
        data["atcCode"] = this.atcCode !== undefined ? this.atcCode : null as any;
        data["articleSummaryHtml"] = this.articleSummaryHtml !== undefined ? this.articleSummaryHtml : null as any;
        data["amountDescription"] = this.amountDescription !== undefined ? this.amountDescription : null as any;
        data["packagingUnit"] = this.packagingUnit !== undefined ? this.packagingUnit : null as any;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null as any;
        data["narcoticClassification"] = this.narcoticClassification ? this.narcoticClassification.toJSON() : null as any;
        return data;
    }
}

export interface IMedicationDto {
    nplPackId?: string | null;
    medicalConsumableId?: string | null;
    nplId?: string | null;
    form?: string | null;
    strength?: string | null;
    interchangeSubstanceGroup?: string | null;
    productName?: string | null;
    packageContainer?: string | null;
    packageDescription?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    amountDescription?: string | null;
    packagingUnit?: string | null;
    manufacturerName?: string | null;
    narcoticClassification?: NarcoticClassificationDto | null;
}

export enum PrescriptionStatus {
    Active = "Active",
    OnHold = "OnHold",
    Cancelled = "Cancelled",
    Completed = "Completed",
    Stopped = "Stopped",
}

export class PrescriptionPriorityInfoDto implements IPrescriptionPriorityInfoDto {
    priority!: PrescriptionPriority;
    displayText!: string;

    constructor(data?: IPrescriptionPriorityInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : null as any;
        }
    }

    static fromJS(data: any): PrescriptionPriorityInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionPriorityInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["displayText"] = this.displayText !== undefined ? this.displayText : null as any;
        return data;
    }
}

export interface IPrescriptionPriorityInfoDto {
    priority: PrescriptionPriority;
    displayText: string;
}

export enum PrescriptionPriority {
    Urgent = "urgent",
}

export enum PrescriptionType {
    Pharmaceutical = "Pharmaceutical",
    MedicalConsumable = "MedicalConsumable",
}

export abstract class PersonDto implements IPersonDto {
    fullName?: string | null;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PersonDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        return data;
    }
}

export interface IPersonDto {
    fullName?: string | null;
}

export class PractitionerDto extends PersonDto implements IPractitionerDto {
    phones!: TelecomDto[];
    role?: string | null;
    workplaceName?: string | null;
    addresses!: AddressDto[];

    constructor(data?: IPractitionerDto) {
        super(data);
        if (!data) {
            this.phones = [];
            this.addresses = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(TelecomDto.fromJS(item));
            }
            else {
                this.phones = null as any;
            }
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.workplaceName = _data["workplaceName"] !== undefined ? _data["workplaceName"] : null as any;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressDto.fromJS(item));
            }
            else {
                this.addresses = null as any;
            }
        }
    }

    static override fromJS(data: any): PractitionerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PractitionerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : null as any);
        }
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["workplaceName"] = this.workplaceName !== undefined ? this.workplaceName : null as any;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPractitionerDto extends IPersonDto {
    phones: TelecomDto[];
    role?: string | null;
    workplaceName?: string | null;
    addresses: AddressDto[];
}

export class TelecomDto implements ITelecomDto {
    phoneNumber!: string;
    availableToPatient!: boolean;
    contactPointType?: string | null;

    constructor(data?: ITelecomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.availableToPatient = _data["availableToPatient"] !== undefined ? _data["availableToPatient"] : null as any;
            this.contactPointType = _data["contactPointType"] !== undefined ? _data["contactPointType"] : null as any;
        }
    }

    static fromJS(data: any): TelecomDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["availableToPatient"] = this.availableToPatient !== undefined ? this.availableToPatient : null as any;
        data["contactPointType"] = this.contactPointType !== undefined ? this.contactPointType : null as any;
        return data;
    }
}

export interface ITelecomDto {
    phoneNumber: string;
    availableToPatient: boolean;
    contactPointType?: string | null;
}

export class AddressDto implements IAddressDto {
    addressType?: AddressType | null;
    line?: string[] | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : null as any;
            if (Array.isArray(_data["line"])) {
                this.line = [] as any;
                for (let item of _data["line"])
                    this.line!.push(item);
            }
            else {
                this.line = null as any;
            }
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressType"] = this.addressType !== undefined ? this.addressType : null as any;
        if (Array.isArray(this.line)) {
            data["line"] = [];
            for (let item of this.line)
                data["line"].push(item);
        }
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }
}

export interface IAddressDto {
    addressType?: AddressType | null;
    line?: string[] | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
}

export enum AddressType {
    Physical = "Physical",
    Postal = "Postal",
    Both = "Both",
}

export class DispenseInformationDto implements IDispenseInformationDto {
    hasTrialDispense!: boolean;
    patientIsEligibleForPharmaceuticalBenefitsAct!: boolean;
    prescriptionIsAccordingToCommunicableDiseasesAct?: boolean | null;
    patientFulfillsConditionsPharmaceuticalBenefitsAct?: boolean | null;
    lastDateOfValidity?: moment.Moment | null;
    firstDispenseBefore?: moment.Moment | null;
    numberOfPackagesPrescribed?: number | null;
    remainingQuantity?: number | null;
    numberOfFillsRemaining?: number | null;
    numberOfDispensesAllowed?: number | null;
    dispenseInterval?: DispenseIntervalDto | null;
    substitutionOpposed?: string | null;
    dosePackaging!: boolean;

    constructor(data?: IDispenseInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTrialDispense = _data["hasTrialDispense"] !== undefined ? _data["hasTrialDispense"] : null as any;
            this.patientIsEligibleForPharmaceuticalBenefitsAct = _data["patientIsEligibleForPharmaceuticalBenefitsAct"] !== undefined ? _data["patientIsEligibleForPharmaceuticalBenefitsAct"] : null as any;
            this.prescriptionIsAccordingToCommunicableDiseasesAct = _data["prescriptionIsAccordingToCommunicableDiseasesAct"] !== undefined ? _data["prescriptionIsAccordingToCommunicableDiseasesAct"] : null as any;
            this.patientFulfillsConditionsPharmaceuticalBenefitsAct = _data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] !== undefined ? _data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] : null as any;
            this.lastDateOfValidity = _data["lastDateOfValidity"] ? moment(_data["lastDateOfValidity"].toString()) : null as any;
            this.firstDispenseBefore = _data["firstDispenseBefore"] ? moment(_data["firstDispenseBefore"].toString()) : null as any;
            this.numberOfPackagesPrescribed = _data["numberOfPackagesPrescribed"] !== undefined ? _data["numberOfPackagesPrescribed"] : null as any;
            this.remainingQuantity = _data["remainingQuantity"] !== undefined ? _data["remainingQuantity"] : null as any;
            this.numberOfFillsRemaining = _data["numberOfFillsRemaining"] !== undefined ? _data["numberOfFillsRemaining"] : null as any;
            this.numberOfDispensesAllowed = _data["numberOfDispensesAllowed"] !== undefined ? _data["numberOfDispensesAllowed"] : null as any;
            this.dispenseInterval = _data["dispenseInterval"] ? DispenseIntervalDto.fromJS(_data["dispenseInterval"]) : null as any;
            this.substitutionOpposed = _data["substitutionOpposed"] !== undefined ? _data["substitutionOpposed"] : null as any;
            this.dosePackaging = _data["dosePackaging"] !== undefined ? _data["dosePackaging"] : null as any;
        }
    }

    static fromJS(data: any): DispenseInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTrialDispense"] = this.hasTrialDispense !== undefined ? this.hasTrialDispense : null as any;
        data["patientIsEligibleForPharmaceuticalBenefitsAct"] = this.patientIsEligibleForPharmaceuticalBenefitsAct !== undefined ? this.patientIsEligibleForPharmaceuticalBenefitsAct : null as any;
        data["prescriptionIsAccordingToCommunicableDiseasesAct"] = this.prescriptionIsAccordingToCommunicableDiseasesAct !== undefined ? this.prescriptionIsAccordingToCommunicableDiseasesAct : null as any;
        data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] = this.patientFulfillsConditionsPharmaceuticalBenefitsAct !== undefined ? this.patientFulfillsConditionsPharmaceuticalBenefitsAct : null as any;
        data["lastDateOfValidity"] = this.lastDateOfValidity ? this.lastDateOfValidity.format('YYYY-MM-DD') : null as any;
        data["firstDispenseBefore"] = this.firstDispenseBefore ? this.firstDispenseBefore.format('YYYY-MM-DD') : null as any;
        data["numberOfPackagesPrescribed"] = this.numberOfPackagesPrescribed !== undefined ? this.numberOfPackagesPrescribed : null as any;
        data["remainingQuantity"] = this.remainingQuantity !== undefined ? this.remainingQuantity : null as any;
        data["numberOfFillsRemaining"] = this.numberOfFillsRemaining !== undefined ? this.numberOfFillsRemaining : null as any;
        data["numberOfDispensesAllowed"] = this.numberOfDispensesAllowed !== undefined ? this.numberOfDispensesAllowed : null as any;
        data["dispenseInterval"] = this.dispenseInterval ? this.dispenseInterval.toJSON() : null as any;
        data["substitutionOpposed"] = this.substitutionOpposed !== undefined ? this.substitutionOpposed : null as any;
        data["dosePackaging"] = this.dosePackaging !== undefined ? this.dosePackaging : null as any;
        return data;
    }
}

export interface IDispenseInformationDto {
    hasTrialDispense: boolean;
    patientIsEligibleForPharmaceuticalBenefitsAct: boolean;
    prescriptionIsAccordingToCommunicableDiseasesAct?: boolean | null;
    patientFulfillsConditionsPharmaceuticalBenefitsAct?: boolean | null;
    lastDateOfValidity?: moment.Moment | null;
    firstDispenseBefore?: moment.Moment | null;
    numberOfPackagesPrescribed?: number | null;
    remainingQuantity?: number | null;
    numberOfFillsRemaining?: number | null;
    numberOfDispensesAllowed?: number | null;
    dispenseInterval?: DispenseIntervalDto | null;
    substitutionOpposed?: string | null;
    dosePackaging: boolean;
}

export class DispenseIntervalDto implements IDispenseIntervalDto {
    value!: number;
    unit!: string;

    constructor(data?: IDispenseIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
        }
    }

    static fromJS(data: any): DispenseIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        return data;
    }
}

export interface IDispenseIntervalDto {
    value: number;
    unit: string;
}

export class NoteDto implements INoteDto {
    noteType!: NoteType;
    noteTypeDisplayText!: string;
    textMarkdown!: string;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : null as any;
            this.noteTypeDisplayText = _data["noteTypeDisplayText"] !== undefined ? _data["noteTypeDisplayText"] : null as any;
            this.textMarkdown = _data["textMarkdown"] !== undefined ? _data["textMarkdown"] : null as any;
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType !== undefined ? this.noteType : null as any;
        data["noteTypeDisplayText"] = this.noteTypeDisplayText !== undefined ? this.noteTypeDisplayText : null as any;
        data["textMarkdown"] = this.textMarkdown !== undefined ? this.textMarkdown : null as any;
        return data;
    }
}

export interface INoteDto {
    noteType: NoteType;
    noteTypeDisplayText: string;
    textMarkdown: string;
}

export enum NoteType {
    PrescriberToCare = "PrescriberToCare",
    PrescriberToPharmacy = "PrescriberToPharmacy",
    Pharmacy = "Pharmacy",
    Delivery = "Delivery",
}

export class PrescriptionReasonDto implements IPrescriptionReasonDto {
    isAbsent!: boolean;
    description?: string | null;
    displayText!: string;

    constructor(data?: IPrescriptionReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAbsent = _data["isAbsent"] !== undefined ? _data["isAbsent"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : null as any;
        }
    }

    static fromJS(data: any): PrescriptionReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAbsent"] = this.isAbsent !== undefined ? this.isAbsent : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["displayText"] = this.displayText !== undefined ? this.displayText : null as any;
        return data;
    }
}

export interface IPrescriptionReasonDto {
    isAbsent: boolean;
    description?: string | null;
    displayText: string;
}

export class MedicationDispenseDto implements IMedicationDispenseDto {
    id!: string;
    version!: number;
    authorizingPrescriptionId!: string;
    authorizingPrescriptionVersion!: number;
    expeditionTime?: moment.Moment | null;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    wasSubstituted!: boolean;
    dispenseType!: string;
    benefitChoice!: string;
    noteMarkdown?: string | null;
    status!: MedicationDispenseStatusType;
    dosageInstructions!: DosageInstructionDto[];
    medication!: MedicationDto;

    constructor(data?: IMedicationDispenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dosageInstructions = [];
            this.medication = new MedicationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.authorizingPrescriptionId = _data["authorizingPrescriptionId"] !== undefined ? _data["authorizingPrescriptionId"] : null as any;
            this.authorizingPrescriptionVersion = _data["authorizingPrescriptionVersion"] !== undefined ? _data["authorizingPrescriptionVersion"] : null as any;
            this.expeditionTime = _data["expeditionTime"] ? moment(_data["expeditionTime"].toString()) : null as any;
            this.creditTime = _data["creditTime"] ? moment(_data["creditTime"].toString()) : null as any;
            this.numberOfPackagesDispensed = _data["numberOfPackagesDispensed"] !== undefined ? _data["numberOfPackagesDispensed"] : null as any;
            this.expeditionQuantity = _data["expeditionQuantity"] !== undefined ? _data["expeditionQuantity"] : null as any;
            this.wasSubstituted = _data["wasSubstituted"] !== undefined ? _data["wasSubstituted"] : null as any;
            this.dispenseType = _data["dispenseType"] !== undefined ? _data["dispenseType"] : null as any;
            this.benefitChoice = _data["benefitChoice"] !== undefined ? _data["benefitChoice"] : null as any;
            this.noteMarkdown = _data["noteMarkdown"] !== undefined ? _data["noteMarkdown"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = null as any;
            }
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
        }
    }

    static fromJS(data: any): MedicationDispenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDispenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["authorizingPrescriptionId"] = this.authorizingPrescriptionId !== undefined ? this.authorizingPrescriptionId : null as any;
        data["authorizingPrescriptionVersion"] = this.authorizingPrescriptionVersion !== undefined ? this.authorizingPrescriptionVersion : null as any;
        data["expeditionTime"] = this.expeditionTime ? this.expeditionTime.toISOString() : null as any;
        data["creditTime"] = this.creditTime ? this.creditTime.toISOString() : null as any;
        data["numberOfPackagesDispensed"] = this.numberOfPackagesDispensed !== undefined ? this.numberOfPackagesDispensed : null as any;
        data["expeditionQuantity"] = this.expeditionQuantity !== undefined ? this.expeditionQuantity : null as any;
        data["wasSubstituted"] = this.wasSubstituted !== undefined ? this.wasSubstituted : null as any;
        data["dispenseType"] = this.dispenseType !== undefined ? this.dispenseType : null as any;
        data["benefitChoice"] = this.benefitChoice !== undefined ? this.benefitChoice : null as any;
        data["noteMarkdown"] = this.noteMarkdown !== undefined ? this.noteMarkdown : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : null as any);
        }
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        return data;
    }
}

export interface IMedicationDispenseDto {
    id: string;
    version: number;
    authorizingPrescriptionId: string;
    authorizingPrescriptionVersion: number;
    expeditionTime?: moment.Moment | null;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    wasSubstituted: boolean;
    dispenseType: string;
    benefitChoice: string;
    noteMarkdown?: string | null;
    status: MedicationDispenseStatusType;
    dosageInstructions: DosageInstructionDto[];
    medication: MedicationDto;
}

export enum MedicationDispenseStatusType {
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export class PrescriptionTimelineResponse implements IPrescriptionTimelineResponse {
    prescriptionId!: string;
    entries!: PrescriptionTimelineEntryResponse[];

    constructor(data?: IPrescriptionTimelineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.entries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(PrescriptionTimelineEntryResponse.fromJS(item));
            }
            else {
                this.entries = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionTimelineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionTimelineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPrescriptionTimelineResponse {
    prescriptionId: string;
    entries: PrescriptionTimelineEntryResponse[];
}

export class PrescriptionTimelineEntryResponse implements IPrescriptionTimelineEntryResponse {
    differences!: DifferenceResponse[];
    timestamp!: moment.Moment;
    employeeId!: string;

    constructor(data?: IPrescriptionTimelineEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.differences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["differences"])) {
                this.differences = [] as any;
                for (let item of _data["differences"])
                    this.differences!.push(DifferenceResponse.fromJS(item));
            }
            else {
                this.differences = null as any;
            }
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : null as any;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : null as any;
        }
    }

    static fromJS(data: any): PrescriptionTimelineEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionTimelineEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item ? item.toJSON() : null as any);
        }
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : null as any;
        return data;
    }
}

export interface IPrescriptionTimelineEntryResponse {
    differences: DifferenceResponse[];
    timestamp: moment.Moment;
    employeeId: string;
}

export class PrescriptionChainTaskConfigResponse implements IPrescriptionChainTaskConfigResponse {
    prescriptionChainId!: string;
    delegationTags!: string[];

    constructor(data?: IPrescriptionChainTaskConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionChainTaskConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainTaskConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IPrescriptionChainTaskConfigResponse {
    prescriptionChainId: string;
    delegationTags: string[];
}

export class UpdateDelegationTagsRequest implements IUpdateDelegationTagsRequest {
    delegationTags!: string[];

    constructor(data?: IUpdateDelegationTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateDelegationTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDelegationTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IUpdateDelegationTagsRequest {
    delegationTags: string[];
}

export class AddPrescriptionChainRequest implements IAddPrescriptionChainRequest {
    prescriptionDtos!: PrescriptionDto[];

    constructor(data?: IAddPrescriptionChainRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prescriptionDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prescriptionDtos"])) {
                this.prescriptionDtos = [] as any;
                for (let item of _data["prescriptionDtos"])
                    this.prescriptionDtos!.push(PrescriptionDto.fromJS(item));
            }
            else {
                this.prescriptionDtos = null as any;
            }
        }
    }

    static fromJS(data: any): AddPrescriptionChainRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPrescriptionChainRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prescriptionDtos)) {
            data["prescriptionDtos"] = [];
            for (let item of this.prescriptionDtos)
                data["prescriptionDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAddPrescriptionChainRequest {
    prescriptionDtos: PrescriptionDto[];
}

export class PrescriptionChainSummaryResponse implements IPrescriptionChainSummaryResponse {
    id!: string;
    residentId!: string;
    hasParallelPrescriptions!: boolean;
    hasUnplannedPrescriptions!: boolean;
    latestPrescription!: PrescriptionResponse;

    constructor(data?: IPrescriptionChainSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.latestPrescription = new PrescriptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.hasParallelPrescriptions = _data["hasParallelPrescriptions"] !== undefined ? _data["hasParallelPrescriptions"] : null as any;
            this.hasUnplannedPrescriptions = _data["hasUnplannedPrescriptions"] !== undefined ? _data["hasUnplannedPrescriptions"] : null as any;
            this.latestPrescription = _data["latestPrescription"] ? PrescriptionResponse.fromJS(_data["latestPrescription"]) : new PrescriptionResponse();
        }
    }

    static fromJS(data: any): PrescriptionChainSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["hasParallelPrescriptions"] = this.hasParallelPrescriptions !== undefined ? this.hasParallelPrescriptions : null as any;
        data["hasUnplannedPrescriptions"] = this.hasUnplannedPrescriptions !== undefined ? this.hasUnplannedPrescriptions : null as any;
        data["latestPrescription"] = this.latestPrescription ? this.latestPrescription.toJSON() : null as any;
        return data;
    }
}

export interface IPrescriptionChainSummaryResponse {
    id: string;
    residentId: string;
    hasParallelPrescriptions: boolean;
    hasUnplannedPrescriptions: boolean;
    latestPrescription: PrescriptionResponse;
}

export class PrescriptionResponse implements IPrescriptionResponse {
    id!: string;
    version!: number;
    prescriptionFormat!: string;
    isPartOfPrescriptionChain!: boolean;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    medication!: MedicationDto;
    treatmentReason?: string | null;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionDto[];
    practitioner!: PractitionerDto;
    dispenseInformation!: DispenseInformationDto;
    notes!: NoteDto[];
    prescriptionReasons!: PrescriptionReasonDto[];

    constructor(data?: IPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerDto();
            this.dispenseInformation = new DispenseInformationDto();
            this.notes = [];
            this.prescriptionReasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : null as any;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : null as any;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : null as any;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : null as any;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : null as any;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : null as any;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoDto.fromJS(_data["priorityInfo"]) : null as any;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : null as any;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : null as any;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : null as any;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : null as any;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = null as any;
            }
            this.practitioner = _data["practitioner"] ? PractitionerDto.fromJS(_data["practitioner"]) : new PractitionerDto();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationDto.fromJS(_data["dispenseInformation"]) : new DispenseInformationDto();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : null as any;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : null as any;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : null as any;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : null as any;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : null as any;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : null as any;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : null as any;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : null as any;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : null as any;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : null as any;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : null as any;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : null as any);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : null as any;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : null as any;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPrescriptionResponse {
    id: string;
    version: number;
    prescriptionFormat: string;
    isPartOfPrescriptionChain: boolean;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    medication: MedicationDto;
    treatmentReason?: string | null;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionDto[];
    practitioner: PractitionerDto;
    dispenseInformation: DispenseInformationDto;
    notes: NoteDto[];
    prescriptionReasons: PrescriptionReasonDto[];
}

export class UpdatePrescriptionChainRequest implements IUpdatePrescriptionChainRequest {
    upsertedPrescriptions!: UpsertPrescriptionRequest[];
    upsertedMedicationDispenses!: MedicationDispenseDto[];

    constructor(data?: IUpdatePrescriptionChainRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.upsertedPrescriptions = [];
            this.upsertedMedicationDispenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["upsertedPrescriptions"])) {
                this.upsertedPrescriptions = [] as any;
                for (let item of _data["upsertedPrescriptions"])
                    this.upsertedPrescriptions!.push(UpsertPrescriptionRequest.fromJS(item));
            }
            else {
                this.upsertedPrescriptions = null as any;
            }
            if (Array.isArray(_data["upsertedMedicationDispenses"])) {
                this.upsertedMedicationDispenses = [] as any;
                for (let item of _data["upsertedMedicationDispenses"])
                    this.upsertedMedicationDispenses!.push(MedicationDispenseDto.fromJS(item));
            }
            else {
                this.upsertedMedicationDispenses = null as any;
            }
        }
    }

    static fromJS(data: any): UpdatePrescriptionChainRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrescriptionChainRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.upsertedPrescriptions)) {
            data["upsertedPrescriptions"] = [];
            for (let item of this.upsertedPrescriptions)
                data["upsertedPrescriptions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.upsertedMedicationDispenses)) {
            data["upsertedMedicationDispenses"] = [];
            for (let item of this.upsertedMedicationDispenses)
                data["upsertedMedicationDispenses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUpdatePrescriptionChainRequest {
    upsertedPrescriptions: UpsertPrescriptionRequest[];
    upsertedMedicationDispenses: MedicationDispenseDto[];
}

export class UpsertPrescriptionRequest implements IUpsertPrescriptionRequest {
    prescriptionId!: string;
    prescriptionDetails!: PrescriptionDetailsRequest;

    constructor(data?: IUpsertPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prescriptionDetails = new PrescriptionDetailsRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.prescriptionDetails = _data["prescriptionDetails"] ? PrescriptionDetailsRequest.fromJS(_data["prescriptionDetails"]) : new PrescriptionDetailsRequest();
        }
    }

    static fromJS(data: any): UpsertPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["prescriptionDetails"] = this.prescriptionDetails ? this.prescriptionDetails.toJSON() : null as any;
        return data;
    }
}

export interface IUpsertPrescriptionRequest {
    prescriptionId: string;
    prescriptionDetails: PrescriptionDetailsRequest;
}

export class PrescriptionDetailsRequest implements IPrescriptionDetailsRequest {
    version!: number;
    prescriptionFormat!: string;
    isPartOfPrescriptionChain!: boolean;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    medication!: MedicationDto;
    treatmentReason?: string | null;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionDto[];
    practitioner!: PractitionerDto;
    dispenseInformation!: DispenseInformationDto;
    notes!: NoteDto[];
    prescriptionReasons!: PrescriptionReasonDto[];

    constructor(data?: IPrescriptionDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerDto();
            this.dispenseInformation = new DispenseInformationDto();
            this.notes = [];
            this.prescriptionReasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : null as any;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : null as any;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : null as any;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : null as any;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : null as any;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : null as any;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoDto.fromJS(_data["priorityInfo"]) : null as any;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : null as any;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : null as any;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : null as any;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : null as any;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = null as any;
            }
            this.practitioner = _data["practitioner"] ? PractitionerDto.fromJS(_data["practitioner"]) : new PractitionerDto();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationDto.fromJS(_data["dispenseInformation"]) : new DispenseInformationDto();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : null as any;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : null as any;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : null as any;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : null as any;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : null as any;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : null as any;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : null as any;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : null as any;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : null as any;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : null as any;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : null as any;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : null as any);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : null as any;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : null as any;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPrescriptionDetailsRequest {
    version: number;
    prescriptionFormat: string;
    isPartOfPrescriptionChain: boolean;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    medication: MedicationDto;
    treatmentReason?: string | null;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionDto[];
    practitioner: PractitionerDto;
    dispenseInformation: DispenseInformationDto;
    notes: NoteDto[];
    prescriptionReasons: PrescriptionReasonDto[];
}

export class PrescriptionChainMetadataResponse implements IPrescriptionChainMetadataResponse {
    prescriptionChainId!: string;
    created!: moment.Moment;
    prescriptionsMetadata!: PrescriptionMetadataResponse[];

    constructor(data?: IPrescriptionChainMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prescriptionsMetadata = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            this.created = _data["created"] ? moment(_data["created"].toString()) : null as any;
            if (Array.isArray(_data["prescriptionsMetadata"])) {
                this.prescriptionsMetadata = [] as any;
                for (let item of _data["prescriptionsMetadata"])
                    this.prescriptionsMetadata!.push(PrescriptionMetadataResponse.fromJS(item));
            }
            else {
                this.prescriptionsMetadata = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionChainMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        if (Array.isArray(this.prescriptionsMetadata)) {
            data["prescriptionsMetadata"] = [];
            for (let item of this.prescriptionsMetadata)
                data["prescriptionsMetadata"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPrescriptionChainMetadataResponse {
    prescriptionChainId: string;
    created: moment.Moment;
    prescriptionsMetadata: PrescriptionMetadataResponse[];
}

export class PrescriptionMetadataResponse implements IPrescriptionMetadataResponse {
    prescriptionId!: string;
    prescriptionVersion!: number;
    lastUpdatedAt!: moment.Moment;
    lastUpdatedBy!: string;
    medicationDispensesMetadata!: MedicationDispenseMetadataResponse[];

    constructor(data?: IPrescriptionMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medicationDispensesMetadata = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.prescriptionVersion = _data["prescriptionVersion"] !== undefined ? _data["prescriptionVersion"] : null as any;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : null as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"] !== undefined ? _data["lastUpdatedBy"] : null as any;
            if (Array.isArray(_data["medicationDispensesMetadata"])) {
                this.medicationDispensesMetadata = [] as any;
                for (let item of _data["medicationDispensesMetadata"])
                    this.medicationDispensesMetadata!.push(MedicationDispenseMetadataResponse.fromJS(item));
            }
            else {
                this.medicationDispensesMetadata = null as any;
            }
        }
    }

    static fromJS(data: any): PrescriptionMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["prescriptionVersion"] = this.prescriptionVersion !== undefined ? this.prescriptionVersion : null as any;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : null as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy !== undefined ? this.lastUpdatedBy : null as any;
        if (Array.isArray(this.medicationDispensesMetadata)) {
            data["medicationDispensesMetadata"] = [];
            for (let item of this.medicationDispensesMetadata)
                data["medicationDispensesMetadata"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPrescriptionMetadataResponse {
    prescriptionId: string;
    prescriptionVersion: number;
    lastUpdatedAt: moment.Moment;
    lastUpdatedBy: string;
    medicationDispensesMetadata: MedicationDispenseMetadataResponse[];
}

export class MedicationDispenseMetadataResponse implements IMedicationDispenseMetadataResponse {
    id!: string;
    version!: number;

    constructor(data?: IMedicationDispenseMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): MedicationDispenseMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDispenseMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export interface IMedicationDispenseMetadataResponse {
    id: string;
    version: number;
}

export class PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse implements IPrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse {
    options!: EffectRegistrationEvaluationTimeOptionResponse[];
    allowUserSelectedTime!: boolean;

    constructor(data?: IPrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.options = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(EffectRegistrationEvaluationTimeOptionResponse.fromJS(item));
            }
            else {
                this.options = null as any;
            }
            this.allowUserSelectedTime = _data["allowUserSelectedTime"] !== undefined ? _data["allowUserSelectedTime"] : null as any;
        }
    }

    static fromJS(data: any): PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        data["allowUserSelectedTime"] = this.allowUserSelectedTime !== undefined ? this.allowUserSelectedTime : null as any;
        return data;
    }
}

export interface IPrescriptionChainEffectRegistrationEvaluationTimeOptionsResponse {
    options: EffectRegistrationEvaluationTimeOptionResponse[];
    allowUserSelectedTime: boolean;
}

export class EffectRegistrationEvaluationTimeOptionResponse implements IEffectRegistrationEvaluationTimeOptionResponse {
    minutes!: number;
    enabled!: boolean;
    isCustomerSpecific!: boolean;

    constructor(data?: IEffectRegistrationEvaluationTimeOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.isCustomerSpecific = _data["isCustomerSpecific"] !== undefined ? _data["isCustomerSpecific"] : null as any;
        }
    }

    static fromJS(data: any): EffectRegistrationEvaluationTimeOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EffectRegistrationEvaluationTimeOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes !== undefined ? this.minutes : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["isCustomerSpecific"] = this.isCustomerSpecific !== undefined ? this.isCustomerSpecific : null as any;
        return data;
    }
}

export interface IEffectRegistrationEvaluationTimeOptionResponse {
    minutes: number;
    enabled: boolean;
    isCustomerSpecific: boolean;
}

export class UpdateEffectRegistrationEvaluationTimeOptionsRequest implements IUpdateEffectRegistrationEvaluationTimeOptionsRequest {
    options!: EffectRegistrationEvaluationTimeOptionRequest[];
    allowUserSelectedTime!: boolean;

    constructor(data?: IUpdateEffectRegistrationEvaluationTimeOptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.options = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(EffectRegistrationEvaluationTimeOptionRequest.fromJS(item));
            }
            else {
                this.options = null as any;
            }
            this.allowUserSelectedTime = _data["allowUserSelectedTime"] !== undefined ? _data["allowUserSelectedTime"] : null as any;
        }
    }

    static fromJS(data: any): UpdateEffectRegistrationEvaluationTimeOptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEffectRegistrationEvaluationTimeOptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        data["allowUserSelectedTime"] = this.allowUserSelectedTime !== undefined ? this.allowUserSelectedTime : null as any;
        return data;
    }
}

export interface IUpdateEffectRegistrationEvaluationTimeOptionsRequest {
    options: EffectRegistrationEvaluationTimeOptionRequest[];
    allowUserSelectedTime: boolean;
}

export class EffectRegistrationEvaluationTimeOptionRequest implements IEffectRegistrationEvaluationTimeOptionRequest {
    minutes!: number;
    enabled!: boolean;

    constructor(data?: IEffectRegistrationEvaluationTimeOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
        }
    }

    static fromJS(data: any): EffectRegistrationEvaluationTimeOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EffectRegistrationEvaluationTimeOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes !== undefined ? this.minutes : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        return data;
    }
}

export interface IEffectRegistrationEvaluationTimeOptionRequest {
    minutes: number;
    enabled: boolean;
}

export class PnPrescriptionResponse implements IPnPrescriptionResponse {
    prescriptionId!: string;
    prescriptionChainId!: string;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    medication!: MedicationDto;
    doseUnit?: string | null;
    dosageInstructionText!: string;
    dosageMaxDosePerPeriod?: DosageMaxDosePerPeriodDto | null;
    hasStrengthConflict!: boolean;
    prescriptionReasons!: PrescriptionReasonDto[];
    administrationSummary!: PrescriptionAdministrationSummaryResponse;
    delegationTags!: string[];
    availableMedications!: AvailableMedicationResponse[];

    constructor(data?: IPnPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.prescriptionReasons = [];
            this.administrationSummary = new PrescriptionAdministrationSummaryResponse();
            this.delegationTags = [];
            this.availableMedications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : null as any;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
            this.dosageInstructionText = _data["dosageInstructionText"] !== undefined ? _data["dosageInstructionText"] : null as any;
            this.dosageMaxDosePerPeriod = _data["dosageMaxDosePerPeriod"] ? DosageMaxDosePerPeriodDto.fromJS(_data["dosageMaxDosePerPeriod"]) : null as any;
            this.hasStrengthConflict = _data["hasStrengthConflict"] !== undefined ? _data["hasStrengthConflict"] : null as any;
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = null as any;
            }
            this.administrationSummary = _data["administrationSummary"] ? PrescriptionAdministrationSummaryResponse.fromJS(_data["administrationSummary"]) : new PrescriptionAdministrationSummaryResponse();
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
            if (Array.isArray(_data["availableMedications"])) {
                this.availableMedications = [] as any;
                for (let item of _data["availableMedications"])
                    this.availableMedications!.push(AvailableMedicationResponse.fromJS(item));
            }
            else {
                this.availableMedications = null as any;
            }
        }
    }

    static fromJS(data: any): PnPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : null as any;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        data["dosageInstructionText"] = this.dosageInstructionText !== undefined ? this.dosageInstructionText : null as any;
        data["dosageMaxDosePerPeriod"] = this.dosageMaxDosePerPeriod ? this.dosageMaxDosePerPeriod.toJSON() : null as any;
        data["hasStrengthConflict"] = this.hasStrengthConflict !== undefined ? this.hasStrengthConflict : null as any;
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : null as any);
        }
        data["administrationSummary"] = this.administrationSummary ? this.administrationSummary.toJSON() : null as any;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        if (Array.isArray(this.availableMedications)) {
            data["availableMedications"] = [];
            for (let item of this.availableMedications)
                data["availableMedications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPnPrescriptionResponse {
    prescriptionId: string;
    prescriptionChainId: string;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    medication: MedicationDto;
    doseUnit?: string | null;
    dosageInstructionText: string;
    dosageMaxDosePerPeriod?: DosageMaxDosePerPeriodDto | null;
    hasStrengthConflict: boolean;
    prescriptionReasons: PrescriptionReasonDto[];
    administrationSummary: PrescriptionAdministrationSummaryResponse;
    delegationTags: string[];
    availableMedications: AvailableMedicationResponse[];
}

export class PrescriptionAdministrationSummaryResponse implements IPrescriptionAdministrationSummaryResponse {
    prescriptionId!: string;
    pnAdministrations!: PnGivenAdministrationResponse[];
    plannedAdministrationSummary!: PlannedAdministrationSummaryResponse;
    administeredAmount!: number;

    constructor(data?: IPrescriptionAdministrationSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.pnAdministrations = [];
            this.plannedAdministrationSummary = new PlannedAdministrationSummaryResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            if (Array.isArray(_data["pnAdministrations"])) {
                this.pnAdministrations = [] as any;
                for (let item of _data["pnAdministrations"])
                    this.pnAdministrations!.push(PnGivenAdministrationResponse.fromJS(item));
            }
            else {
                this.pnAdministrations = null as any;
            }
            this.plannedAdministrationSummary = _data["plannedAdministrationSummary"] ? PlannedAdministrationSummaryResponse.fromJS(_data["plannedAdministrationSummary"]) : new PlannedAdministrationSummaryResponse();
            this.administeredAmount = _data["administeredAmount"] !== undefined ? _data["administeredAmount"] : null as any;
        }
    }

    static fromJS(data: any): PrescriptionAdministrationSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionAdministrationSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        if (Array.isArray(this.pnAdministrations)) {
            data["pnAdministrations"] = [];
            for (let item of this.pnAdministrations)
                data["pnAdministrations"].push(item ? item.toJSON() : null as any);
        }
        data["plannedAdministrationSummary"] = this.plannedAdministrationSummary ? this.plannedAdministrationSummary.toJSON() : null as any;
        data["administeredAmount"] = this.administeredAmount !== undefined ? this.administeredAmount : null as any;
        return data;
    }
}

export interface IPrescriptionAdministrationSummaryResponse {
    prescriptionId: string;
    pnAdministrations: PnGivenAdministrationResponse[];
    plannedAdministrationSummary: PlannedAdministrationSummaryResponse;
    administeredAmount: number;
}

export class PnGivenAdministrationResponse implements IPnGivenAdministrationResponse {
    givenAt!: moment.Moment;
    givenBy!: string;
    nplId!: string;
    amount!: number;
    state!: PnMedicineTaskState;

    constructor(data?: IPnGivenAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
            this.givenBy = _data["givenBy"] !== undefined ? _data["givenBy"] : null as any;
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): PnGivenAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnGivenAdministrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        data["givenBy"] = this.givenBy !== undefined ? this.givenBy : null as any;
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IPnGivenAdministrationResponse {
    givenAt: moment.Moment;
    givenBy: string;
    nplId: string;
    amount: number;
    state: PnMedicineTaskState;
}

export enum PnMedicineTaskState {
    Given = "Given",
    Cancelled = "Cancelled",
}

export class PlannedAdministrationSummaryResponse implements IPlannedAdministrationSummaryResponse {
    givenAdministrations!: PlannedGivenAdministrationResponse[];
    scheduledAdministrations!: ScheduledAdministrationResponse[];

    constructor(data?: IPlannedAdministrationSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.givenAdministrations = [];
            this.scheduledAdministrations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["givenAdministrations"])) {
                this.givenAdministrations = [] as any;
                for (let item of _data["givenAdministrations"])
                    this.givenAdministrations!.push(PlannedGivenAdministrationResponse.fromJS(item));
            }
            else {
                this.givenAdministrations = null as any;
            }
            if (Array.isArray(_data["scheduledAdministrations"])) {
                this.scheduledAdministrations = [] as any;
                for (let item of _data["scheduledAdministrations"])
                    this.scheduledAdministrations!.push(ScheduledAdministrationResponse.fromJS(item));
            }
            else {
                this.scheduledAdministrations = null as any;
            }
        }
    }

    static fromJS(data: any): PlannedAdministrationSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.givenAdministrations)) {
            data["givenAdministrations"] = [];
            for (let item of this.givenAdministrations)
                data["givenAdministrations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.scheduledAdministrations)) {
            data["scheduledAdministrations"] = [];
            for (let item of this.scheduledAdministrations)
                data["scheduledAdministrations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlannedAdministrationSummaryResponse {
    givenAdministrations: PlannedGivenAdministrationResponse[];
    scheduledAdministrations: ScheduledAdministrationResponse[];
}

export abstract class PlannedGivenAdministrationResponse implements IPlannedGivenAdministrationResponse {
    givenAt!: moment.Moment;
    givenBy!: string;
    state!: PlannedMedicineTaskState;

    protected _discriminator: string;

    constructor(data?: IPlannedGivenAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PlannedGivenAdministrationResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
            this.givenBy = _data["givenBy"] !== undefined ? _data["givenBy"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): PlannedGivenAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MedicationGivenAdministrationResponse") {
            let result = new MedicationGivenAdministrationResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "GroupedMedicationGivenAdministrationResponse") {
            let result = new GroupedMedicationGivenAdministrationResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PlannedGivenAdministrationResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        data["givenBy"] = this.givenBy !== undefined ? this.givenBy : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IPlannedGivenAdministrationResponse {
    givenAt: moment.Moment;
    givenBy: string;
    state: PlannedMedicineTaskState;
}

export enum PlannedMedicineTaskState {
    None = "None",
    Given = "Given",
    NotGiven = "NotGiven",
    NotIngested = "NotIngested",
    PartiallyGiven = "PartiallyGiven",
}

export class MedicationGivenAdministrationResponse extends PlannedGivenAdministrationResponse implements IMedicationGivenAdministrationResponse {
    givenMedications!: MedicationAmountResponse[];

    constructor(data?: IMedicationGivenAdministrationResponse) {
        super(data);
        if (!data) {
            this.givenMedications = [];
        }
        this._discriminator = "MedicationGivenAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["givenMedications"])) {
                this.givenMedications = [] as any;
                for (let item of _data["givenMedications"])
                    this.givenMedications!.push(MedicationAmountResponse.fromJS(item));
            }
            else {
                this.givenMedications = null as any;
            }
        }
    }

    static override fromJS(data: any): MedicationGivenAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationGivenAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.givenMedications)) {
            data["givenMedications"] = [];
            for (let item of this.givenMedications)
                data["givenMedications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationGivenAdministrationResponse extends IPlannedGivenAdministrationResponse {
    givenMedications: MedicationAmountResponse[];
}

export class MedicationAmountResponse implements IMedicationAmountResponse {
    nplId!: string;
    amountGiven!: number;

    constructor(data?: IMedicationAmountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.amountGiven = _data["amountGiven"] !== undefined ? _data["amountGiven"] : null as any;
        }
    }

    static fromJS(data: any): MedicationAmountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationAmountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["amountGiven"] = this.amountGiven !== undefined ? this.amountGiven : null as any;
        return data;
    }
}

export interface IMedicationAmountResponse {
    nplId: string;
    amountGiven: number;
}

export class GroupedMedicationGivenAdministrationResponse extends PlannedGivenAdministrationResponse implements IGroupedMedicationGivenAdministrationResponse {
    amount!: number;

    constructor(data?: IGroupedMedicationGivenAdministrationResponse) {
        super(data);
        this._discriminator = "GroupedMedicationGivenAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static override fromJS(data: any): GroupedMedicationGivenAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedMedicationGivenAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGroupedMedicationGivenAdministrationResponse extends IPlannedGivenAdministrationResponse {
    amount: number;
}

export abstract class ScheduledAdministrationResponse implements IScheduledAdministrationResponse {
    scheduledTime!: moment.Moment;
    amount?: number | null;

    protected _discriminator: string;

    constructor(data?: IScheduledAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ScheduledAdministrationResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledTime = _data["scheduledTime"] ? moment(_data["scheduledTime"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): ScheduledAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ScheduledOriginalPackagingAdministrationResponse") {
            let result = new ScheduledOriginalPackagingAdministrationResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ScheduledDosePackagingAdministrationResponse") {
            let result = new ScheduledDosePackagingAdministrationResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ScheduledDispensedPackagingAdministrationResponse") {
            let result = new ScheduledDispensedPackagingAdministrationResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ScheduledAdministrationResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toISOString() : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

export interface IScheduledAdministrationResponse {
    scheduledTime: moment.Moment;
    amount?: number | null;
}

export class ScheduledOriginalPackagingAdministrationResponse extends ScheduledAdministrationResponse implements IScheduledOriginalPackagingAdministrationResponse {

    constructor(data?: IScheduledOriginalPackagingAdministrationResponse) {
        super(data);
        this._discriminator = "ScheduledOriginalPackagingAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ScheduledOriginalPackagingAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledOriginalPackagingAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IScheduledOriginalPackagingAdministrationResponse extends IScheduledAdministrationResponse {
}

export class ScheduledDosePackagingAdministrationResponse extends ScheduledAdministrationResponse implements IScheduledDosePackagingAdministrationResponse {

    constructor(data?: IScheduledDosePackagingAdministrationResponse) {
        super(data);
        this._discriminator = "ScheduledDosePackagingAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ScheduledDosePackagingAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledDosePackagingAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IScheduledDosePackagingAdministrationResponse extends IScheduledAdministrationResponse {
}

export class ScheduledDispensedPackagingAdministrationResponse extends ScheduledAdministrationResponse implements IScheduledDispensedPackagingAdministrationResponse {

    constructor(data?: IScheduledDispensedPackagingAdministrationResponse) {
        super(data);
        this._discriminator = "ScheduledDispensedPackagingAdministrationResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ScheduledDispensedPackagingAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledDispensedPackagingAdministrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IScheduledDispensedPackagingAdministrationResponse extends IScheduledAdministrationResponse {
}

export class AvailableMedicationResponse implements IAvailableMedicationResponse {
    medication!: MedicationDto;
    additionalDosageInstructionTexts!: string[];

    constructor(data?: IAvailableMedicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.additionalDosageInstructionTexts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            if (Array.isArray(_data["additionalDosageInstructionTexts"])) {
                this.additionalDosageInstructionTexts = [] as any;
                for (let item of _data["additionalDosageInstructionTexts"])
                    this.additionalDosageInstructionTexts!.push(item);
            }
            else {
                this.additionalDosageInstructionTexts = null as any;
            }
        }
    }

    static fromJS(data: any): AvailableMedicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableMedicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        if (Array.isArray(this.additionalDosageInstructionTexts)) {
            data["additionalDosageInstructionTexts"] = [];
            for (let item of this.additionalDosageInstructionTexts)
                data["additionalDosageInstructionTexts"].push(item);
        }
        return data;
    }
}

export interface IAvailableMedicationResponse {
    medication: MedicationDto;
    additionalDosageInstructionTexts: string[];
}

export class GivePnMedicineRequest implements IGivePnMedicineRequest {
    givenAt!: moment.Moment;
    amount!: number;
    reason!: string;
    evaluationTimeMinutesOffset!: number;
    effect?: string | null;

    constructor(data?: IGivePnMedicineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.evaluationTimeMinutesOffset = _data["evaluationTimeMinutesOffset"] !== undefined ? _data["evaluationTimeMinutesOffset"] : null as any;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : null as any;
        }
    }

    static fromJS(data: any): GivePnMedicineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GivePnMedicineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["evaluationTimeMinutesOffset"] = this.evaluationTimeMinutesOffset !== undefined ? this.evaluationTimeMinutesOffset : null as any;
        data["effect"] = this.effect !== undefined ? this.effect : null as any;
        return data;
    }
}

export interface IGivePnMedicineRequest {
    givenAt: moment.Moment;
    amount: number;
    reason: string;
    evaluationTimeMinutesOffset: number;
    effect?: string | null;
}

export abstract class PnTaskResponse implements IPnTaskResponse {
    id!: string;
    residentId!: string;
    prescriptionId!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;

    protected _discriminator: string;

    constructor(data?: IPnTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PnTaskResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PnTaskResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "PnMedicineTaskResponse") {
            let result = new PnMedicineTaskResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PnMedicineEffectTaskResponse") {
            let result = new PnMedicineEffectTaskResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnTaskResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        return data;
    }
}

export interface IPnTaskResponse {
    id: string;
    residentId: string;
    prescriptionId: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class PnMedicineTaskResponse extends PnTaskResponse implements IPnMedicineTaskResponse {
    state!: PnMedicineTaskState;

    constructor(data?: IPnMedicineTaskResponse) {
        super(data);
        this._discriminator = "PnMedicineTaskResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static override fromJS(data: any): PnMedicineTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnMedicineTaskResponse extends IPnTaskResponse {
    state: PnMedicineTaskState;
}

export class PnMedicineEffectTaskResponse extends PnTaskResponse implements IPnMedicineEffectTaskResponse {
    pnMedicineTaskId!: string;
    state!: PnMedicineEffectTaskState;

    constructor(data?: IPnMedicineEffectTaskResponse) {
        super(data);
        this._discriminator = "PnMedicineEffectTaskResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnMedicineTaskId = _data["pnMedicineTaskId"] !== undefined ? _data["pnMedicineTaskId"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static override fromJS(data: any): PnMedicineEffectTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineEffectTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnMedicineTaskId"] = this.pnMedicineTaskId !== undefined ? this.pnMedicineTaskId : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnMedicineEffectTaskResponse extends IPnTaskResponse {
    pnMedicineTaskId: string;
    state: PnMedicineEffectTaskState;
}

export enum PnMedicineEffectTaskState {
    None = "None",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export class GetPnTasksRequest implements IGetPnTasksRequest {
    residentIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IGetPnTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = null as any;
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? moment(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GetPnTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPnTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IGetPnTasksRequest {
    residentIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class PnMedicineTaskDetailResponse implements IPnMedicineTaskDetailResponse {
    id!: string;
    residentId!: string;
    medication!: MedicationDto;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    state!: PnMedicineTaskState;
    prescriptionId!: string;
    amount!: number;
    reason!: string;
    doseUnit?: string | null;
    history!: PnMedicineHistoryEntryResponse[];
    delegationTags!: string[];

    constructor(data?: IPnMedicineTaskDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.history = [];
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PnMedicineHistoryEntryResponse.fromJS(item));
            }
            else {
                this.history = null as any;
            }
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): PnMedicineTaskDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineTaskDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IPnMedicineTaskDetailResponse {
    id: string;
    residentId: string;
    medication: MedicationDto;
    startTime: moment.Moment;
    endTime: moment.Moment;
    state: PnMedicineTaskState;
    prescriptionId: string;
    amount: number;
    reason: string;
    doseUnit?: string | null;
    history: PnMedicineHistoryEntryResponse[];
    delegationTags: string[];
}

export class PnMedicineHistoryEntryResponse implements IPnMedicineHistoryEntryResponse {
    timestamp!: moment.Moment;
    performedBy!: string;

    protected _discriminator: string;

    constructor(data?: IPnMedicineHistoryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PnMedicineHistoryEntryResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : null as any;
            this.performedBy = _data["performedBy"] !== undefined ? _data["performedBy"] : null as any;
        }
    }

    static fromJS(data: any): PnMedicineHistoryEntryResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "PnMedicineGivenEntryResponse") {
            let result = new PnMedicineGivenEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PnMedicineCancelledEntryResponse") {
            let result = new PnMedicineCancelledEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PnMedicineEffectRegisteredEntryResponse") {
            let result = new PnMedicineEffectRegisteredEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PnMedicineEffectUpdatedEntryResponse") {
            let result = new PnMedicineEffectUpdatedEntryResponse();
            result.init(data);
            return result;
        }
        let result = new PnMedicineHistoryEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["performedBy"] = this.performedBy !== undefined ? this.performedBy : null as any;
        return data;
    }
}

export interface IPnMedicineHistoryEntryResponse {
    timestamp: moment.Moment;
    performedBy: string;
}

export class PnMedicineGivenEntryResponse extends PnMedicineHistoryEntryResponse implements IPnMedicineGivenEntryResponse {
    givenAt!: moment.Moment;
    amount!: number;

    constructor(data?: IPnMedicineGivenEntryResponse) {
        super(data);
        this._discriminator = "PnMedicineGivenEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static override fromJS(data: any): PnMedicineGivenEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineGivenEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnMedicineGivenEntryResponse extends IPnMedicineHistoryEntryResponse {
    givenAt: moment.Moment;
    amount: number;
}

export class PnMedicineCancelledEntryResponse extends PnMedicineHistoryEntryResponse implements IPnMedicineCancelledEntryResponse {

    constructor(data?: IPnMedicineCancelledEntryResponse) {
        super(data);
        this._discriminator = "PnMedicineCancelledEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PnMedicineCancelledEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineCancelledEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnMedicineCancelledEntryResponse extends IPnMedicineHistoryEntryResponse {
}

export class PnMedicineEffectRegisteredEntryResponse extends PnMedicineHistoryEntryResponse implements IPnMedicineEffectRegisteredEntryResponse {
    effect!: string;

    constructor(data?: IPnMedicineEffectRegisteredEntryResponse) {
        super(data);
        this._discriminator = "PnMedicineEffectRegisteredEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.effect = _data["effect"] !== undefined ? _data["effect"] : null as any;
        }
    }

    static override fromJS(data: any): PnMedicineEffectRegisteredEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineEffectRegisteredEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect"] = this.effect !== undefined ? this.effect : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnMedicineEffectRegisteredEntryResponse extends IPnMedicineHistoryEntryResponse {
    effect: string;
}

export class PnMedicineEffectUpdatedEntryResponse extends PnMedicineHistoryEntryResponse implements IPnMedicineEffectUpdatedEntryResponse {
    effect!: string;

    constructor(data?: IPnMedicineEffectUpdatedEntryResponse) {
        super(data);
        this._discriminator = "PnMedicineEffectUpdatedEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.effect = _data["effect"] !== undefined ? _data["effect"] : null as any;
        }
    }

    static override fromJS(data: any): PnMedicineEffectUpdatedEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineEffectUpdatedEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect"] = this.effect !== undefined ? this.effect : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnMedicineEffectUpdatedEntryResponse extends IPnMedicineHistoryEntryResponse {
    effect: string;
}

export class PnMedicineEffectTaskDetailResponse implements IPnMedicineEffectTaskDetailResponse {
    pnMedicineTaskId!: string;
    residentId!: string;
    medication!: MedicationDto;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    state!: PnMedicineEffectTaskState;
    prescriptionId!: string;
    amount!: number;
    reason!: string;
    effect?: string | null;
    doseUnit?: string | null;
    history!: PnMedicineHistoryEntryResponse[];

    constructor(data?: IPnMedicineEffectTaskDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.history = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnMedicineTaskId = _data["pnMedicineTaskId"] !== undefined ? _data["pnMedicineTaskId"] : null as any;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : null as any;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PnMedicineHistoryEntryResponse.fromJS(item));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): PnMedicineEffectTaskDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnMedicineEffectTaskDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnMedicineTaskId"] = this.pnMedicineTaskId !== undefined ? this.pnMedicineTaskId : null as any;
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["effect"] = this.effect !== undefined ? this.effect : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPnMedicineEffectTaskDetailResponse {
    pnMedicineTaskId: string;
    residentId: string;
    medication: MedicationDto;
    startTime: moment.Moment;
    endTime: moment.Moment;
    state: PnMedicineEffectTaskState;
    prescriptionId: string;
    amount: number;
    reason: string;
    effect?: string | null;
    doseUnit?: string | null;
    history: PnMedicineHistoryEntryResponse[];
}

export class RegisterEffectRequest implements IRegisterEffectRequest {
    effect!: string;

    constructor(data?: IRegisterEffectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effect = _data["effect"] !== undefined ? _data["effect"] : null as any;
        }
    }

    static fromJS(data: any): RegisterEffectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterEffectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect"] = this.effect !== undefined ? this.effect : null as any;
        return data;
    }
}

export interface IRegisterEffectRequest {
    effect: string;
}

export class PrescriptionChainPlanningResponse implements IPrescriptionChainPlanningResponse {
    prescriptionChainId!: string;
    planningActivated!: boolean;
    prescriptionPlannings!: PrescriptionPlanningResponse[];
    planningActivationChangedAt?: moment.Moment | null;

    constructor(data?: IPrescriptionChainPlanningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prescriptionPlannings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            this.planningActivated = _data["planningActivated"] !== undefined ? _data["planningActivated"] : null as any;
            if (Array.isArray(_data["prescriptionPlannings"])) {
                this.prescriptionPlannings = [] as any;
                for (let item of _data["prescriptionPlannings"])
                    this.prescriptionPlannings!.push(PrescriptionPlanningResponse.fromJS(item));
            }
            else {
                this.prescriptionPlannings = null as any;
            }
            this.planningActivationChangedAt = _data["planningActivationChangedAt"] ? moment(_data["planningActivationChangedAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PrescriptionChainPlanningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainPlanningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        data["planningActivated"] = this.planningActivated !== undefined ? this.planningActivated : null as any;
        if (Array.isArray(this.prescriptionPlannings)) {
            data["prescriptionPlannings"] = [];
            for (let item of this.prescriptionPlannings)
                data["prescriptionPlannings"].push(item ? item.toJSON() : null as any);
        }
        data["planningActivationChangedAt"] = this.planningActivationChangedAt ? this.planningActivationChangedAt.toISOString() : null as any;
        return data;
    }
}

export interface IPrescriptionChainPlanningResponse {
    prescriptionChainId: string;
    planningActivated: boolean;
    prescriptionPlannings: PrescriptionPlanningResponse[];
    planningActivationChangedAt?: moment.Moment | null;
}

export class PrescriptionPlanningResponse implements IPrescriptionPlanningResponse {
    prescriptionId!: string;
    authoredOn!: moment.Moment;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    status!: PrescriptionStatus;
    medication!: MedicationDto;
    medicationDispenses!: MedicationDispenseDto[];
    planning!: PlanningResponse;

    constructor(data?: IPrescriptionPlanningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.medicationDispenses = [];
            this.planning = new PlanningResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : null as any;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : null as any;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            if (Array.isArray(_data["medicationDispenses"])) {
                this.medicationDispenses = [] as any;
                for (let item of _data["medicationDispenses"])
                    this.medicationDispenses!.push(MedicationDispenseDto.fromJS(item));
            }
            else {
                this.medicationDispenses = null as any;
            }
            this.planning = _data["planning"] ? PlanningResponse.fromJS(_data["planning"]) : new PlanningResponse();
        }
    }

    static fromJS(data: any): PrescriptionPlanningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionPlanningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : null as any;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : null as any;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["medication"] = this.medication ? this.medication.toJSON() : null as any;
        if (Array.isArray(this.medicationDispenses)) {
            data["medicationDispenses"] = [];
            for (let item of this.medicationDispenses)
                data["medicationDispenses"].push(item ? item.toJSON() : null as any);
        }
        data["planning"] = this.planning ? this.planning.toJSON() : null as any;
        return data;
    }
}

export interface IPrescriptionPlanningResponse {
    prescriptionId: string;
    authoredOn: moment.Moment;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    status: PrescriptionStatus;
    medication: MedicationDto;
    medicationDispenses: MedicationDispenseDto[];
    planning: PlanningResponse;
}

export class PlanningResponse implements IPlanningResponse {
    id!: string;
    recurrencePatterns!: RecurrencePatternResponse[];

    constructor(data?: IPlanningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.recurrencePatterns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["recurrencePatterns"])) {
                this.recurrencePatterns = [] as any;
                for (let item of _data["recurrencePatterns"])
                    this.recurrencePatterns!.push(RecurrencePatternResponse.fromJS(item));
            }
            else {
                this.recurrencePatterns = null as any;
            }
        }
    }

    static fromJS(data: any): PlanningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.recurrencePatterns)) {
            data["recurrencePatterns"] = [];
            for (let item of this.recurrencePatterns)
                data["recurrencePatterns"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlanningResponse {
    id: string;
    recurrencePatterns: RecurrencePatternResponse[];
}

export abstract class RecurrencePatternResponse implements IRecurrencePatternResponse {
    id!: string;
    start!: moment.Moment;
    end?: moment.Moment | null;
    dispensedMedication!: boolean;

    protected _discriminator: string;

    constructor(data?: IRecurrencePatternResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "RecurrencePatternResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
            this.dispensedMedication = _data["dispensedMedication"] !== undefined ? _data["dispensedMedication"] : null as any;
        }
    }

    static fromJS(data: any): RecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DailyRecurrencePatternResponse") {
            let result = new DailyRecurrencePatternResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "WeeklyRecurrencePatternResponse") {
            let result = new WeeklyRecurrencePatternResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "CyclicDailyRecurrencePatternResponse") {
            let result = new CyclicDailyRecurrencePatternResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RecurrencePatternResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        data["dispensedMedication"] = this.dispensedMedication !== undefined ? this.dispensedMedication : null as any;
        return data;
    }
}

export interface IRecurrencePatternResponse {
    id: string;
    start: moment.Moment;
    end?: moment.Moment | null;
    dispensedMedication: boolean;
}

export class DailyRecurrencePatternResponse extends RecurrencePatternResponse implements IDailyRecurrencePatternResponse {
    plannedAdministrations!: PlannedAdministrationResponse[];
    interval!: number;

    constructor(data?: IDailyRecurrencePatternResponse) {
        super(data);
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "DailyRecurrencePatternResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationResponse.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
        }
    }

    static override fromJS(data: any): DailyRecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRecurrencePatternResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDailyRecurrencePatternResponse extends IRecurrencePatternResponse {
    plannedAdministrations: PlannedAdministrationResponse[];
    interval: number;
}

export class WeeklyRecurrencePatternResponse extends RecurrencePatternResponse implements IWeeklyRecurrencePatternResponse {
    weekAdministrations!: DayOfWeekAdministrationsResponse[];
    interval!: number;

    constructor(data?: IWeeklyRecurrencePatternResponse) {
        super(data);
        if (!data) {
            this.weekAdministrations = [];
        }
        this._discriminator = "WeeklyRecurrencePatternResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["weekAdministrations"])) {
                this.weekAdministrations = [] as any;
                for (let item of _data["weekAdministrations"])
                    this.weekAdministrations!.push(DayOfWeekAdministrationsResponse.fromJS(item));
            }
            else {
                this.weekAdministrations = null as any;
            }
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
        }
    }

    static override fromJS(data: any): WeeklyRecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRecurrencePatternResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weekAdministrations)) {
            data["weekAdministrations"] = [];
            for (let item of this.weekAdministrations)
                data["weekAdministrations"].push(item ? item.toJSON() : null as any);
        }
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWeeklyRecurrencePatternResponse extends IRecurrencePatternResponse {
    weekAdministrations: DayOfWeekAdministrationsResponse[];
    interval: number;
}

export class CyclicDailyRecurrencePatternResponse extends RecurrencePatternResponse implements ICyclicDailyRecurrencePatternResponse {
    subsequences!: SubsequenceResponse[];

    constructor(data?: ICyclicDailyRecurrencePatternResponse) {
        super(data);
        if (!data) {
            this.subsequences = [];
        }
        this._discriminator = "CyclicDailyRecurrencePatternResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["subsequences"])) {
                this.subsequences = [] as any;
                for (let item of _data["subsequences"])
                    this.subsequences!.push(SubsequenceResponse.fromJS(item));
            }
            else {
                this.subsequences = null as any;
            }
        }
    }

    static override fromJS(data: any): CyclicDailyRecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CyclicDailyRecurrencePatternResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subsequences)) {
            data["subsequences"] = [];
            for (let item of this.subsequences)
                data["subsequences"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICyclicDailyRecurrencePatternResponse extends IRecurrencePatternResponse {
    subsequences: SubsequenceResponse[];
}

export abstract class SubsequenceResponse implements ISubsequenceResponse {
    order!: number;
    numberOfDays!: number;

    protected _discriminator: string;

    constructor(data?: ISubsequenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SubsequenceResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.numberOfDays = _data["numberOfDays"] !== undefined ? _data["numberOfDays"] : null as any;
        }
    }

    static fromJS(data: any): SubsequenceResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "SubsequencePauseResponse") {
            let result = new SubsequencePauseResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SubsequenceWithAdministrationsResponse") {
            let result = new SubsequenceWithAdministrationsResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SubsequenceResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["numberOfDays"] = this.numberOfDays !== undefined ? this.numberOfDays : null as any;
        return data;
    }
}

export interface ISubsequenceResponse {
    order: number;
    numberOfDays: number;
}

export class SubsequencePauseResponse extends SubsequenceResponse implements ISubsequencePauseResponse {

    constructor(data?: ISubsequencePauseResponse) {
        super(data);
        this._discriminator = "SubsequencePauseResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubsequencePauseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubsequencePauseResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubsequencePauseResponse extends ISubsequenceResponse {
}

export class SubsequenceWithAdministrationsResponse extends SubsequenceResponse implements ISubsequenceWithAdministrationsResponse {
    plannedAdministrations!: PlannedAdministrationResponse[];

    constructor(data?: ISubsequenceWithAdministrationsResponse) {
        super(data);
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "SubsequenceWithAdministrationsResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationResponse.fromJS(item));
            }
            else {
                this.plannedAdministrations = null as any;
            }
        }
    }

    static override fromJS(data: any): SubsequenceWithAdministrationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubsequenceWithAdministrationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubsequenceWithAdministrationsResponse extends ISubsequenceResponse {
    plannedAdministrations: PlannedAdministrationResponse[];
}

export class DispensedPackagingTaskDetailResponse implements IDispensedPackagingTaskDetailResponse {
    residentId!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    id!: string;
    state!: PlannedMedicineTaskState;
    version!: number;
    delegationTags!: string[];
    dosage!: Dosage;
    history!: PlannedMedicineTaskHistoryEntryResponse[];

    constructor(data?: IDispensedPackagingTaskDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
            this.dosage = new Dosage();
            this.history = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
            this.dosage = _data["dosage"] ? Dosage.fromJS(_data["dosage"]) : new Dosage();
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PlannedMedicineTaskHistoryEntryResponse.fromJS(item));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): DispensedPackagingTaskDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DispensedPackagingTaskDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        data["dosage"] = this.dosage ? this.dosage.toJSON() : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDispensedPackagingTaskDetailResponse {
    residentId: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
    id: string;
    state: PlannedMedicineTaskState;
    version: number;
    delegationTags: string[];
    dosage: Dosage;
    history: PlannedMedicineTaskHistoryEntryResponse[];
}

export class Dosage implements IDosage {
    prescriptionDosages!: PrescriptionDosage[];
    wholePills!: number;
    halfPills!: number;
    quarterPills!: number;

    constructor(data?: IDosage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prescriptionDosages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prescriptionDosages"])) {
                this.prescriptionDosages = [] as any;
                for (let item of _data["prescriptionDosages"])
                    this.prescriptionDosages!.push(PrescriptionDosage.fromJS(item));
            }
            else {
                this.prescriptionDosages = null as any;
            }
            this.wholePills = _data["wholePills"] !== undefined ? _data["wholePills"] : null as any;
            this.halfPills = _data["halfPills"] !== undefined ? _data["halfPills"] : null as any;
            this.quarterPills = _data["quarterPills"] !== undefined ? _data["quarterPills"] : null as any;
        }
    }

    static fromJS(data: any): Dosage {
        data = typeof data === 'object' ? data : {};
        let result = new Dosage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prescriptionDosages)) {
            data["prescriptionDosages"] = [];
            for (let item of this.prescriptionDosages)
                data["prescriptionDosages"].push(item ? item.toJSON() : null as any);
        }
        data["wholePills"] = this.wholePills !== undefined ? this.wholePills : null as any;
        data["halfPills"] = this.halfPills !== undefined ? this.halfPills : null as any;
        data["quarterPills"] = this.quarterPills !== undefined ? this.quarterPills : null as any;
        return data;
    }
}

export interface IDosage {
    prescriptionDosages: PrescriptionDosage[];
    wholePills: number;
    halfPills: number;
    quarterPills: number;
}

export class PrescriptionDosage implements IPrescriptionDosage {
    prescriptionId!: string;
    wholePills!: number;
    halfPills!: number;
    quarterPills!: number;
    totalPills!: number;

    constructor(data?: IPrescriptionDosage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.wholePills = _data["wholePills"] !== undefined ? _data["wholePills"] : null as any;
            this.halfPills = _data["halfPills"] !== undefined ? _data["halfPills"] : null as any;
            this.quarterPills = _data["quarterPills"] !== undefined ? _data["quarterPills"] : null as any;
            this.totalPills = _data["totalPills"] !== undefined ? _data["totalPills"] : null as any;
        }
    }

    static fromJS(data: any): PrescriptionDosage {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDosage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["wholePills"] = this.wholePills !== undefined ? this.wholePills : null as any;
        data["halfPills"] = this.halfPills !== undefined ? this.halfPills : null as any;
        data["quarterPills"] = this.quarterPills !== undefined ? this.quarterPills : null as any;
        data["totalPills"] = this.totalPills !== undefined ? this.totalPills : null as any;
        return data;
    }
}

export interface IPrescriptionDosage {
    prescriptionId: string;
    wholePills: number;
    halfPills: number;
    quarterPills: number;
    totalPills: number;
}

export abstract class PlannedMedicineTaskHistoryEntryResponse implements IPlannedMedicineTaskHistoryEntryResponse {
    timestamp!: moment.Moment;
    performedById!: string;

    protected _discriminator: string;

    constructor(data?: IPlannedMedicineTaskHistoryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PlannedMedicineTaskHistoryEntryResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : null as any;
            this.performedById = _data["performedById"] !== undefined ? _data["performedById"] : null as any;
        }
    }

    static fromJS(data: any): PlannedMedicineTaskHistoryEntryResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "PlannedMedicineTaskActionEntryResponse") {
            let result = new PlannedMedicineTaskActionEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MedicationGivenActionEntryResponse") {
            let result = new MedicationGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "AmountMedicationGivenActionEntryResponse") {
            let result = new AmountMedicationGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MedicationPartiallyGivenActionEntryResponse") {
            let result = new MedicationPartiallyGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PlannedMedicineTaskHistoryEntryResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["performedById"] = this.performedById !== undefined ? this.performedById : null as any;
        return data;
    }
}

export interface IPlannedMedicineTaskHistoryEntryResponse {
    timestamp: moment.Moment;
    performedById: string;
}

export class PlannedMedicineTaskActionEntryResponse extends PlannedMedicineTaskHistoryEntryResponse implements IPlannedMedicineTaskActionEntryResponse {
    action!: PlannedMedicineTaskActionType;
    reason?: string | null;

    constructor(data?: IPlannedMedicineTaskActionEntryResponse) {
        super(data);
        this._discriminator = "PlannedMedicineTaskActionEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static override fromJS(data: any): PlannedMedicineTaskActionEntryResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MedicationGivenActionEntryResponse") {
            let result = new MedicationGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "AmountMedicationGivenActionEntryResponse") {
            let result = new AmountMedicationGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MedicationPartiallyGivenActionEntryResponse") {
            let result = new MedicationPartiallyGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        let result = new PlannedMedicineTaskActionEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPlannedMedicineTaskActionEntryResponse extends IPlannedMedicineTaskHistoryEntryResponse {
    action: PlannedMedicineTaskActionType;
    reason?: string | null;
}

export enum PlannedMedicineTaskActionType {
    MedicationGiven = "MedicationGiven",
    MedicationGivenUndone = "MedicationGivenUndone",
    MedicationNotGiven = "MedicationNotGiven",
    MedicationNotGivenUndone = "MedicationNotGivenUndone",
    MedicationNotIngested = "MedicationNotIngested",
    MedicationNotIngestedUndone = "MedicationNotIngestedUndone",
    MedicationPartiallyGiven = "MedicationPartiallyGiven",
    MedicationPartiallyGivenUndone = "MedicationPartiallyGivenUndone",
}

export class MedicationGivenActionEntryResponse extends PlannedMedicineTaskActionEntryResponse implements IMedicationGivenActionEntryResponse {
    givenAt!: moment.Moment;

    constructor(data?: IMedicationGivenActionEntryResponse) {
        super(data);
        this._discriminator = "MedicationGivenActionEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): MedicationGivenActionEntryResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AmountMedicationGivenActionEntryResponse") {
            let result = new AmountMedicationGivenActionEntryResponse();
            result.init(data);
            return result;
        }
        let result = new MedicationGivenActionEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationGivenActionEntryResponse extends IPlannedMedicineTaskActionEntryResponse {
    givenAt: moment.Moment;
}

export class AmountMedicationGivenActionEntryResponse extends MedicationGivenActionEntryResponse implements IAmountMedicationGivenActionEntryResponse {
    givenMedications!: MedicationAmountResponse[];

    constructor(data?: IAmountMedicationGivenActionEntryResponse) {
        super(data);
        if (!data) {
            this.givenMedications = [];
        }
        this._discriminator = "AmountMedicationGivenActionEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["givenMedications"])) {
                this.givenMedications = [] as any;
                for (let item of _data["givenMedications"])
                    this.givenMedications!.push(MedicationAmountResponse.fromJS(item));
            }
            else {
                this.givenMedications = null as any;
            }
        }
    }

    static override fromJS(data: any): AmountMedicationGivenActionEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AmountMedicationGivenActionEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.givenMedications)) {
            data["givenMedications"] = [];
            for (let item of this.givenMedications)
                data["givenMedications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAmountMedicationGivenActionEntryResponse extends IMedicationGivenActionEntryResponse {
    givenMedications: MedicationAmountResponse[];
}

export class MedicationPartiallyGivenActionEntryResponse extends PlannedMedicineTaskActionEntryResponse implements IMedicationPartiallyGivenActionEntryResponse {
    givenAt!: moment.Moment;

    constructor(data?: IMedicationPartiallyGivenActionEntryResponse) {
        super(data);
        this._discriminator = "MedicationPartiallyGivenActionEntryResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): MedicationPartiallyGivenActionEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationPartiallyGivenActionEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationPartiallyGivenActionEntryResponse extends IPlannedMedicineTaskActionEntryResponse {
    givenAt: moment.Moment;
}

export class GiveMedicationRequest implements IGiveMedicationRequest {
    expectedCurrentVersion!: number;
    givenAt!: moment.Moment;

    constructor(data?: IGiveMedicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GiveMedicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GiveMedicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        return data;
    }
}

export interface IGiveMedicationRequest {
    expectedCurrentVersion: number;
    givenAt: moment.Moment;
}

export class ActionWithReasonRequest implements IActionWithReasonRequest {
    expectedCurrentVersion!: number;
    reason!: string;

    constructor(data?: IActionWithReasonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): ActionWithReasonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActionWithReasonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }
}

export interface IActionWithReasonRequest {
    expectedCurrentVersion: number;
    reason: string;
}

export class MedicationPartiallyGivenRequest implements IMedicationPartiallyGivenRequest {
    expectedCurrentVersion!: number;
    reason!: string;
    givenAt!: moment.Moment;

    constructor(data?: IMedicationPartiallyGivenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MedicationPartiallyGivenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationPartiallyGivenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        return data;
    }
}

export interface IMedicationPartiallyGivenRequest {
    expectedCurrentVersion: number;
    reason: string;
    givenAt: moment.Moment;
}

export class DosePackagingTaskDetailResponse implements IDosePackagingTaskDetailResponse {
    residentId!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    id!: string;
    state!: PlannedMedicineTaskState;
    version!: number;
    delegationTags!: string[];
    dosage!: Dosage;
    history!: PlannedMedicineTaskHistoryEntryResponse[];

    constructor(data?: IDosePackagingTaskDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
            this.dosage = new Dosage();
            this.history = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
            this.dosage = _data["dosage"] ? Dosage.fromJS(_data["dosage"]) : new Dosage();
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PlannedMedicineTaskHistoryEntryResponse.fromJS(item));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): DosePackagingTaskDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosePackagingTaskDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        data["dosage"] = this.dosage ? this.dosage.toJSON() : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDosePackagingTaskDetailResponse {
    residentId: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
    id: string;
    state: PlannedMedicineTaskState;
    version: number;
    delegationTags: string[];
    dosage: Dosage;
    history: PlannedMedicineTaskHistoryEntryResponse[];
}

export class OriginalPackagingTaskDetailResponse implements IOriginalPackagingTaskDetailResponse {
    residentId!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    id!: string;
    state!: PlannedMedicineTaskState;
    version!: number;
    isReadOnly!: boolean;
    plannedAmount?: number | null;
    doseUnit?: string | null;
    prescriptionDosageInstructionText!: string;
    delegationTags!: string[];
    history!: PlannedMedicineTaskHistoryEntryResponse[];
    availableMedications!: AvailableMedicationResponse[];

    constructor(data?: IOriginalPackagingTaskDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
            this.history = [];
            this.availableMedications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.isReadOnly = _data["isReadOnly"] !== undefined ? _data["isReadOnly"] : null as any;
            this.plannedAmount = _data["plannedAmount"] !== undefined ? _data["plannedAmount"] : null as any;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
            this.prescriptionDosageInstructionText = _data["prescriptionDosageInstructionText"] !== undefined ? _data["prescriptionDosageInstructionText"] : null as any;
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PlannedMedicineTaskHistoryEntryResponse.fromJS(item));
            }
            else {
                this.history = null as any;
            }
            if (Array.isArray(_data["availableMedications"])) {
                this.availableMedications = [] as any;
                for (let item of _data["availableMedications"])
                    this.availableMedications!.push(AvailableMedicationResponse.fromJS(item));
            }
            else {
                this.availableMedications = null as any;
            }
        }
    }

    static fromJS(data: any): OriginalPackagingTaskDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OriginalPackagingTaskDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["isReadOnly"] = this.isReadOnly !== undefined ? this.isReadOnly : null as any;
        data["plannedAmount"] = this.plannedAmount !== undefined ? this.plannedAmount : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        data["prescriptionDosageInstructionText"] = this.prescriptionDosageInstructionText !== undefined ? this.prescriptionDosageInstructionText : null as any;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.availableMedications)) {
            data["availableMedications"] = [];
            for (let item of this.availableMedications)
                data["availableMedications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOriginalPackagingTaskDetailResponse {
    residentId: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
    id: string;
    state: PlannedMedicineTaskState;
    version: number;
    isReadOnly: boolean;
    plannedAmount?: number | null;
    doseUnit?: string | null;
    prescriptionDosageInstructionText: string;
    delegationTags: string[];
    history: PlannedMedicineTaskHistoryEntryResponse[];
    availableMedications: AvailableMedicationResponse[];
}

export class GiveMedicationWithAmountRequest implements IGiveMedicationWithAmountRequest {
    expectedCurrentVersion!: number;
    givenAt!: moment.Moment;
    givenMedications!: MedicationAmountRequest[];

    constructor(data?: IGiveMedicationWithAmountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.givenMedications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedCurrentVersion = _data["expectedCurrentVersion"] !== undefined ? _data["expectedCurrentVersion"] : null as any;
            this.givenAt = _data["givenAt"] ? moment(_data["givenAt"].toString()) : null as any;
            if (Array.isArray(_data["givenMedications"])) {
                this.givenMedications = [] as any;
                for (let item of _data["givenMedications"])
                    this.givenMedications!.push(MedicationAmountRequest.fromJS(item));
            }
            else {
                this.givenMedications = null as any;
            }
        }
    }

    static fromJS(data: any): GiveMedicationWithAmountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GiveMedicationWithAmountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedCurrentVersion"] = this.expectedCurrentVersion !== undefined ? this.expectedCurrentVersion : null as any;
        data["givenAt"] = this.givenAt ? this.givenAt.toISOString() : null as any;
        if (Array.isArray(this.givenMedications)) {
            data["givenMedications"] = [];
            for (let item of this.givenMedications)
                data["givenMedications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGiveMedicationWithAmountRequest {
    expectedCurrentVersion: number;
    givenAt: moment.Moment;
    givenMedications: MedicationAmountRequest[];
}

export class MedicationAmountRequest implements IMedicationAmountRequest {
    nplId!: string;
    amountGiven!: number;

    constructor(data?: IMedicationAmountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.amountGiven = _data["amountGiven"] !== undefined ? _data["amountGiven"] : null as any;
        }
    }

    static fromJS(data: any): MedicationAmountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationAmountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["amountGiven"] = this.amountGiven !== undefined ? this.amountGiven : null as any;
        return data;
    }
}

export interface IMedicationAmountRequest {
    nplId: string;
    amountGiven: number;
}

export abstract class PlannedMedicineTaskResponse implements IPlannedMedicineTaskResponse {
    residentId!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    id!: string;
    state!: PlannedMedicineTaskState;
    version!: number;

    protected _discriminator: string;

    constructor(data?: IPlannedMedicineTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PlannedMedicineTaskResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): PlannedMedicineTaskResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "OriginalPackagingTaskResponse") {
            let result = new OriginalPackagingTaskResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DosePackagingTaskResponse") {
            let result = new DosePackagingTaskResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DispensedPackagingTaskResponse") {
            let result = new DispensedPackagingTaskResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PlannedMedicineTaskResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export interface IPlannedMedicineTaskResponse {
    residentId: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
    id: string;
    state: PlannedMedicineTaskState;
    version: number;
}

export class OriginalPackagingTaskResponse extends PlannedMedicineTaskResponse implements IOriginalPackagingTaskResponse {
    isReadOnly!: boolean;
    plannedAmount?: number | null;
    doseUnit?: string | null;

    constructor(data?: IOriginalPackagingTaskResponse) {
        super(data);
        this._discriminator = "OriginalPackagingTaskResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isReadOnly = _data["isReadOnly"] !== undefined ? _data["isReadOnly"] : null as any;
            this.plannedAmount = _data["plannedAmount"] !== undefined ? _data["plannedAmount"] : null as any;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : null as any;
        }
    }

    static override fromJS(data: any): OriginalPackagingTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OriginalPackagingTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReadOnly"] = this.isReadOnly !== undefined ? this.isReadOnly : null as any;
        data["plannedAmount"] = this.plannedAmount !== undefined ? this.plannedAmount : null as any;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOriginalPackagingTaskResponse extends IPlannedMedicineTaskResponse {
    isReadOnly: boolean;
    plannedAmount?: number | null;
    doseUnit?: string | null;
}

export class DosePackagingTaskResponse extends PlannedMedicineTaskResponse implements IDosePackagingTaskResponse {

    constructor(data?: IDosePackagingTaskResponse) {
        super(data);
        this._discriminator = "DosePackagingTaskResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DosePackagingTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosePackagingTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDosePackagingTaskResponse extends IPlannedMedicineTaskResponse {
}

export class DispensedPackagingTaskResponse extends PlannedMedicineTaskResponse implements IDispensedPackagingTaskResponse {

    constructor(data?: IDispensedPackagingTaskResponse) {
        super(data);
        this._discriminator = "DispensedPackagingTaskResponse";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DispensedPackagingTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DispensedPackagingTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDispensedPackagingTaskResponse extends IPlannedMedicineTaskResponse {
}

export class PlannedMedicineTasksForResidentsRequest implements IPlannedMedicineTasksForResidentsRequest {
    residentIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IPlannedMedicineTasksForResidentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = null as any;
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? moment(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PlannedMedicineTasksForResidentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedMedicineTasksForResidentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IPlannedMedicineTasksForResidentsRequest {
    residentIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class PreviewChangesResponse implements IPreviewChangesResponse {
    conflicting!: PlannedMedicineTaskResponse[];
    new!: PlannedMedicineTaskResponse[];
    reintroducing!: PlannedMedicineTaskResponse[];
    readOnly!: PlannedMedicineTaskResponse[];
    removable!: PlannedMedicineTaskResponse[];
    unaffected!: PlannedMedicineTaskResponse[];

    constructor(data?: IPreviewChangesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conflicting = [];
            this.new = [];
            this.reintroducing = [];
            this.readOnly = [];
            this.removable = [];
            this.unaffected = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conflicting"])) {
                this.conflicting = [] as any;
                for (let item of _data["conflicting"])
                    this.conflicting!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                this.conflicting = null as any;
            }
            if (Array.isArray(_data["new"])) {
                this.new = [] as any;
                for (let item of _data["new"])
                    this.new!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                this.new = null as any;
            }
            if (Array.isArray(_data["reintroducing"])) {
                this.reintroducing = [] as any;
                for (let item of _data["reintroducing"])
                    this.reintroducing!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                this.reintroducing = null as any;
            }
            if (Array.isArray(_data["readOnly"])) {
                this.readOnly = [] as any;
                for (let item of _data["readOnly"])
                    this.readOnly!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                this.readOnly = null as any;
            }
            if (Array.isArray(_data["removable"])) {
                this.removable = [] as any;
                for (let item of _data["removable"])
                    this.removable!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                this.removable = null as any;
            }
            if (Array.isArray(_data["unaffected"])) {
                this.unaffected = [] as any;
                for (let item of _data["unaffected"])
                    this.unaffected!.push(PlannedMedicineTaskResponse.fromJS(item));
            }
            else {
                this.unaffected = null as any;
            }
        }
    }

    static fromJS(data: any): PreviewChangesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewChangesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conflicting)) {
            data["conflicting"] = [];
            for (let item of this.conflicting)
                data["conflicting"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.new)) {
            data["new"] = [];
            for (let item of this.new)
                data["new"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.reintroducing)) {
            data["reintroducing"] = [];
            for (let item of this.reintroducing)
                data["reintroducing"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.readOnly)) {
            data["readOnly"] = [];
            for (let item of this.readOnly)
                data["readOnly"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.removable)) {
            data["removable"] = [];
            for (let item of this.removable)
                data["removable"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.unaffected)) {
            data["unaffected"] = [];
            for (let item of this.unaffected)
                data["unaffected"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPreviewChangesResponse {
    conflicting: PlannedMedicineTaskResponse[];
    new: PlannedMedicineTaskResponse[];
    reintroducing: PlannedMedicineTaskResponse[];
    readOnly: PlannedMedicineTaskResponse[];
    removable: PlannedMedicineTaskResponse[];
    unaffected: PlannedMedicineTaskResponse[];
}

export class PreviewChangesRequest implements IPreviewChangesRequest {
    residentId!: string;
    prescriptionChainId!: string;
    prescriptionId!: string;
    updatedRecurrencePatternIntervalStart!: moment.Moment;
    updatedRecurrencePatternIntervalEnd?: moment.Moment | null;

    constructor(data?: IPreviewChangesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : null as any;
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : null as any;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            this.updatedRecurrencePatternIntervalStart = _data["updatedRecurrencePatternIntervalStart"] ? moment(_data["updatedRecurrencePatternIntervalStart"].toString()) : null as any;
            this.updatedRecurrencePatternIntervalEnd = _data["updatedRecurrencePatternIntervalEnd"] ? moment(_data["updatedRecurrencePatternIntervalEnd"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PreviewChangesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewChangesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : null as any;
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : null as any;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        data["updatedRecurrencePatternIntervalStart"] = this.updatedRecurrencePatternIntervalStart ? this.updatedRecurrencePatternIntervalStart.toISOString() : null as any;
        data["updatedRecurrencePatternIntervalEnd"] = this.updatedRecurrencePatternIntervalEnd ? this.updatedRecurrencePatternIntervalEnd.toISOString() : null as any;
        return data;
    }
}

export interface IPreviewChangesRequest {
    residentId: string;
    prescriptionChainId: string;
    prescriptionId: string;
    updatedRecurrencePatternIntervalStart: moment.Moment;
    updatedRecurrencePatternIntervalEnd?: moment.Moment | null;
}

export class MedicineTaskOrganisationConfigurationResponse implements IMedicineTaskOrganisationConfigurationResponse {
    originalPackagingTaskConfiguration!: OriginalPackagingTaskConfigurationResponse;
    dosePackagingTaskConfiguration!: DosePackagingTaskConfigurationResponse;
    dispensedPackagingTaskConfiguration!: DispensedPackagingTaskConfigurationResponse;
    pnTaskConfiguration!: PnTaskConfigurationResponse;
    dosageRouteTaskConfiguration!: DosageRouteTaskConfigurationResponse;

    constructor(data?: IMedicineTaskOrganisationConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.originalPackagingTaskConfiguration = new OriginalPackagingTaskConfigurationResponse();
            this.dosePackagingTaskConfiguration = new DosePackagingTaskConfigurationResponse();
            this.dispensedPackagingTaskConfiguration = new DispensedPackagingTaskConfigurationResponse();
            this.pnTaskConfiguration = new PnTaskConfigurationResponse();
            this.dosageRouteTaskConfiguration = new DosageRouteTaskConfigurationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalPackagingTaskConfiguration = _data["originalPackagingTaskConfiguration"] ? OriginalPackagingTaskConfigurationResponse.fromJS(_data["originalPackagingTaskConfiguration"]) : new OriginalPackagingTaskConfigurationResponse();
            this.dosePackagingTaskConfiguration = _data["dosePackagingTaskConfiguration"] ? DosePackagingTaskConfigurationResponse.fromJS(_data["dosePackagingTaskConfiguration"]) : new DosePackagingTaskConfigurationResponse();
            this.dispensedPackagingTaskConfiguration = _data["dispensedPackagingTaskConfiguration"] ? DispensedPackagingTaskConfigurationResponse.fromJS(_data["dispensedPackagingTaskConfiguration"]) : new DispensedPackagingTaskConfigurationResponse();
            this.pnTaskConfiguration = _data["pnTaskConfiguration"] ? PnTaskConfigurationResponse.fromJS(_data["pnTaskConfiguration"]) : new PnTaskConfigurationResponse();
            this.dosageRouteTaskConfiguration = _data["dosageRouteTaskConfiguration"] ? DosageRouteTaskConfigurationResponse.fromJS(_data["dosageRouteTaskConfiguration"]) : new DosageRouteTaskConfigurationResponse();
        }
    }

    static fromJS(data: any): MedicineTaskOrganisationConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicineTaskOrganisationConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalPackagingTaskConfiguration"] = this.originalPackagingTaskConfiguration ? this.originalPackagingTaskConfiguration.toJSON() : null as any;
        data["dosePackagingTaskConfiguration"] = this.dosePackagingTaskConfiguration ? this.dosePackagingTaskConfiguration.toJSON() : null as any;
        data["dispensedPackagingTaskConfiguration"] = this.dispensedPackagingTaskConfiguration ? this.dispensedPackagingTaskConfiguration.toJSON() : null as any;
        data["pnTaskConfiguration"] = this.pnTaskConfiguration ? this.pnTaskConfiguration.toJSON() : null as any;
        data["dosageRouteTaskConfiguration"] = this.dosageRouteTaskConfiguration ? this.dosageRouteTaskConfiguration.toJSON() : null as any;
        return data;
    }
}

export interface IMedicineTaskOrganisationConfigurationResponse {
    originalPackagingTaskConfiguration: OriginalPackagingTaskConfigurationResponse;
    dosePackagingTaskConfiguration: DosePackagingTaskConfigurationResponse;
    dispensedPackagingTaskConfiguration: DispensedPackagingTaskConfigurationResponse;
    pnTaskConfiguration: PnTaskConfigurationResponse;
    dosageRouteTaskConfiguration: DosageRouteTaskConfigurationResponse;
}

export class OriginalPackagingTaskConfigurationResponse implements IOriginalPackagingTaskConfigurationResponse {
    delegationTags!: string[];

    constructor(data?: IOriginalPackagingTaskConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): OriginalPackagingTaskConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OriginalPackagingTaskConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IOriginalPackagingTaskConfigurationResponse {
    delegationTags: string[];
}

export class DosePackagingTaskConfigurationResponse implements IDosePackagingTaskConfigurationResponse {
    delegationTags!: string[];

    constructor(data?: IDosePackagingTaskConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): DosePackagingTaskConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosePackagingTaskConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IDosePackagingTaskConfigurationResponse {
    delegationTags: string[];
}

export class DispensedPackagingTaskConfigurationResponse implements IDispensedPackagingTaskConfigurationResponse {
    delegationTags!: string[];

    constructor(data?: IDispensedPackagingTaskConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): DispensedPackagingTaskConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DispensedPackagingTaskConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IDispensedPackagingTaskConfigurationResponse {
    delegationTags: string[];
}

export class PnTaskConfigurationResponse implements IPnTaskConfigurationResponse {
    delegationTags!: string[];

    constructor(data?: IPnTaskConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): PnTaskConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnTaskConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IPnTaskConfigurationResponse {
    delegationTags: string[];
}

export class DosageRouteTaskConfigurationResponse implements IDosageRouteTaskConfigurationResponse {
    delegationTagConfigurations!: DosageRouteDelegationTagConfigurationResponse[];

    constructor(data?: IDosageRouteTaskConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTagConfigurations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTagConfigurations"])) {
                this.delegationTagConfigurations = [] as any;
                for (let item of _data["delegationTagConfigurations"])
                    this.delegationTagConfigurations!.push(DosageRouteDelegationTagConfigurationResponse.fromJS(item));
            }
            else {
                this.delegationTagConfigurations = null as any;
            }
        }
    }

    static fromJS(data: any): DosageRouteTaskConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRouteTaskConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTagConfigurations)) {
            data["delegationTagConfigurations"] = [];
            for (let item of this.delegationTagConfigurations)
                data["delegationTagConfigurations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDosageRouteTaskConfigurationResponse {
    delegationTagConfigurations: DosageRouteDelegationTagConfigurationResponse[];
}

export class DosageRouteDelegationTagConfigurationResponse implements IDosageRouteDelegationTagConfigurationResponse {
    code!: string;
    delegationTags!: string[];

    constructor(data?: IDosageRouteDelegationTagConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): DosageRouteDelegationTagConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRouteDelegationTagConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IDosageRouteDelegationTagConfigurationResponse {
    code: string;
    delegationTags: string[];
}

export class UpsertDelegationTagConfigurationRequest implements IUpsertDelegationTagConfigurationRequest {
    delegationTags!: string[];

    constructor(data?: IUpsertDelegationTagConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): UpsertDelegationTagConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDelegationTagConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IUpsertDelegationTagConfigurationRequest {
    delegationTags: string[];
}

export class UpsertDosageRouteDelegationTagConfigurationRequest implements IUpsertDosageRouteDelegationTagConfigurationRequest {
    delegationTags!: string[];

    constructor(data?: IUpsertDosageRouteDelegationTagConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            else {
                this.delegationTags = null as any;
            }
        }
    }

    static fromJS(data: any): UpsertDosageRouteDelegationTagConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDosageRouteDelegationTagConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        return data;
    }
}

export interface IUpsertDosageRouteDelegationTagConfigurationRequest {
    delegationTags: string[];
}

export class MedicationConfigurationResponse implements IMedicationConfigurationResponse {
    prescriptionId!: string;
    medications!: MedicationOptionResponse[];

    constructor(data?: IMedicationConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.medications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : null as any;
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications!.push(MedicationOptionResponse.fromJS(item));
            }
            else {
                this.medications = null as any;
            }
        }
    }

    static fromJS(data: any): MedicationConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : null as any;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMedicationConfigurationResponse {
    prescriptionId: string;
    medications: MedicationOptionResponse[];
}

export class MedicationOptionResponse implements IMedicationOptionResponse {
    nplId!: string;
    productName?: string | null;
    strength?: string | null;
    packagingUnit?: string | null;
    isAvailable!: boolean;

    constructor(data?: IMedicationOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : null as any;
            this.packagingUnit = _data["packagingUnit"] !== undefined ? _data["packagingUnit"] : null as any;
            this.isAvailable = _data["isAvailable"] !== undefined ? _data["isAvailable"] : null as any;
        }
    }

    static fromJS(data: any): MedicationOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplId"] = this.nplId !== undefined ? this.nplId : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["strength"] = this.strength !== undefined ? this.strength : null as any;
        data["packagingUnit"] = this.packagingUnit !== undefined ? this.packagingUnit : null as any;
        data["isAvailable"] = this.isAvailable !== undefined ? this.isAvailable : null as any;
        return data;
    }
}

export interface IMedicationOptionResponse {
    nplId: string;
    productName?: string | null;
    strength?: string | null;
    packagingUnit?: string | null;
    isAvailable: boolean;
}

export class UpdateMedicationConfigurationRequest implements IUpdateMedicationConfigurationRequest {
    availableMedicationNplIds!: string[];

    constructor(data?: IUpdateMedicationConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.availableMedicationNplIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableMedicationNplIds"])) {
                this.availableMedicationNplIds = [] as any;
                for (let item of _data["availableMedicationNplIds"])
                    this.availableMedicationNplIds!.push(item);
            }
            else {
                this.availableMedicationNplIds = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateMedicationConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicationConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableMedicationNplIds)) {
            data["availableMedicationNplIds"] = [];
            for (let item of this.availableMedicationNplIds)
                data["availableMedicationNplIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateMedicationConfigurationRequest {
    availableMedicationNplIds: string[];
}

export class AddEffectRegistrationEvaluationTimeOptionRequest implements IAddEffectRegistrationEvaluationTimeOptionRequest {
    minutes!: number;
    shouldBeActiveOnModifiedChainConfigs!: boolean;

    constructor(data?: IAddEffectRegistrationEvaluationTimeOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : null as any;
            this.shouldBeActiveOnModifiedChainConfigs = _data["shouldBeActiveOnModifiedChainConfigs"] !== undefined ? _data["shouldBeActiveOnModifiedChainConfigs"] : null as any;
        }
    }

    static fromJS(data: any): AddEffectRegistrationEvaluationTimeOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddEffectRegistrationEvaluationTimeOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes !== undefined ? this.minutes : null as any;
        data["shouldBeActiveOnModifiedChainConfigs"] = this.shouldBeActiveOnModifiedChainConfigs !== undefined ? this.shouldBeActiveOnModifiedChainConfigs : null as any;
        return data;
    }
}

export interface IAddEffectRegistrationEvaluationTimeOptionRequest {
    minutes: number;
    shouldBeActiveOnModifiedChainConfigs: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}